import adminRequest from 'utils/adminRequest'
import studentRequest from 'utils/studentRequest'
import authRequest from 'utils/authRequest'
import elasticSearchRequest from 'utils/elasticSearchRequest'
import { systemConfig } from 'utils/config'
import qs from 'qs'
import ErrorMessage from 'utils/ErrorMessage'
import { selectDegreeSearchResults } from './selectors'
import { latestRequest } from './latestRequest'
import elasticSearchSyncRequest from 'utils/elasticSearchSyncRequest'

// In-memory TTL cache for the 4 cascading filter-dropdown actions
// (getAssessmentDomains/Degrees/Departments/Specializations). Same payload
// for the same param signature within TTL — cuts repeated calls fired by
// Promise.all on the institute-list / TPO student-list mounts. 5-minute TTL
// keeps it small and self-healing.
const FILTER_CACHE_TTL_MS = 5 * 60 * 1000
const filterCache = new Map()
const filterInflight = new Map()
function filterCacheKey(name, params) {
  return name + '|' + JSON.stringify(params)
}
async function withFilterCache(name, params, loader) {
  const key = filterCacheKey(name, params)
  const now = Date.now()
  const hit = filterCache.get(key)
  if (hit && hit.expiresAt > now) return hit.value
  if (filterInflight.has(key)) return filterInflight.get(key)
  const promise = (async () => {
    try {
      const value = await loader()
      filterCache.set(key, { value, expiresAt: Date.now() + FILTER_CACHE_TTL_MS })
      return value
    } finally {
      filterInflight.delete(key)
    }
  })()
  filterInflight.set(key, promise)
  return promise
}


export const SET_SUBSCRIBED_INSTITUTES = 'SET_SUBSCRIBED_INSTITUTES'
export const SET_SUBSCRIPTION_RENEWAL_INSTITUTES =
  'SET_SUBSCRIPTION_RENEWAL_INSTITUTES'
export const SET_SELECTED_INSTITUTE = 'SET_SELECTED_INSTITUTE'
export const SET_LOADING = 'SET_LOADING'
export const SET_ERROR = 'SET_ERROR'
export const SET_TOTAL_COLLEGE_COUNT = 'SET_TOTAL_COLLEGE_COUNT'
export const SET_ACTIVE_ASSESSMENT_COUNT = 'SET_ACTIVE_ASSESSMENT_COUNT'
export const SET_ASSESSMENT_SENT_COUNT = 'SET_ASSESSMENT_SENT_COUNT'
export const SET_ASSESSMENT_COMPLETED_COUNT = 'SET_ASSESSMENT_COMPLETED_COUNT'
export const SET_SUBSCRIBED_INSTITUTES_SUBSCRIBED_COUNT =
  'SET_SUBSCRIBED_INSTITUTES_SUBSCRIBED_COUNT'
export const SET_SUBSCRIBED_INSTITUTES_TRIAL_COUNT =
  'SET_SUBSCRIBED_INSTITUTES_TRIAL_COUNT'
export const SET_SUBSCRIPTION_RENEWAL_SUBSCRIBED_COUNT =
  'SET_SUBSCRIPTION_RENEWAL_SUBSCRIBED_COUNT'
export const SET_SUBSCRIPTION_RENEWAL_TRIAL_COUNT =
  'SET_SUBSCRIPTION_RENEWAL_TRIAL_COUNT'
export const SET_SUBSCRIBED_INSTITUTES_PAGINATION =
  'SET_SUBSCRIBED_INSTITUTES_PAGINATION'
export const SET_SUBSCRIPTION_RENEWAL_PAGINATION =
  'SET_SUBSCRIPTION_RENEWAL_PAGINATION'
export const SET_FILTERS = 'SET_FILTERS'
export const UPDATE_PAGE = 'UPDATE_PAGE'
export const RESET_FILTERS = 'RESET_FILTERS'
export const RESET_STATE = 'RESET_STATE'
export const SET_INSTITUTES_STATES = 'SET_INSTITUTES_STATES'
export const SET_INSTITUTES_CITIES = 'SET_INSTITUTES_CITIES'
export const SET_INSTITUTES_BY_CITY = 'SET_INSTITUTES_BY_CITY'
export const SET_ASSESSMENT_BY_INSTITUTE = 'SET_ASSESSMENT_BY_INSTITUTE'
export const FETCH_APTITUDE_TOPICS_REQUEST = 'FETCH_APTITUDE_TOPICS_REQUEST'
export const FETCH_APTITUDE_TOPICS_SUCCESS = 'FETCH_APTITUDE_TOPICS_SUCCESS'
export const FETCH_APTITUDE_TOPICS_FAILURE = 'FETCH_APTITUDE_TOPICS_FAILURE'

export const FETCH_APTITUDE_CONFIG_REQUEST = 'FETCH_APTITUDE_CONFIG_REQUEST'
export const FETCH_APTITUDE_CONFIG_SUCCESS = 'FETCH_APTITUDE_CONFIG_SUCCESS'
export const FETCH_APTITUDE_CONFIG_FAILURE = 'FETCH_APTITUDE_CONFIG_FAILURE'
export const FETCH_SPECIFIC_ASSESSMENT_STUDENT_LIST_REQUEST = 'FETCH_SPECIFIC_ASSESSMENT_STUDENT_LIST_REQUEST';
export const FETCH_SPECIFIC_ASSESSMENT_STUDENT_LIST_SUCCESS = 'FETCH_SPECIFIC_ASSESSMENT_STUDENT_LIST_SUCCESS';
export const FETCH_SPECIFIC_ASSESSMENT_STUDENT_LIST_FAILURE = 'FETCH_SPECIFIC_ASSESSMENT_STUDENT_LIST_FAILURE';
export const SET_DEGREE_SEARCH_RESULTS = 'SET_DEGREE_SEARCH_RESULTS'
export const SET_DEGREE_SEARCH_LOADING = 'SET_DEGREE_SEARCH_LOADING'
export const SET_DEGREE_SEARCH_ERROR = 'SET_DEGREE_SEARCH_ERROR'
export const SET_DEGREE_SELECTION = 'SET_DEGREE_SELECTION'
export const SET_ACTIVE_ASSESSMENTS = 'SET_ACTIVE_ASSESSMENTS'
export const SET_COMPLETED_ASSESSMENTS = 'SET_COMPLETED_ASSESSMENTS'
export const SET_ACTIVE_ASSESSMENTS_PAGINATION =
  'SET_ACTIVE_ASSESSMENTS_PAGINATION'
export const SET_COMPLETED_ASSESSMENTS_PAGINATION =
  'SET_COMPLETED_ASSESSMENTS_PAGINATION'

export const SET_ACTIVE_ASSESSMENTS_METRICS = 'SET_ACTIVE_ASSESSMENTS_METRICS'
export const SET_COMPLETED_ASSESSMENTS_METRICS =
  'SET_COMPLETED_ASSESSMENTS_METRICS'
export const SET_RECENT_ACTIVITY_LOGS = 'SET_RECENT_ACTIVITY_LOGS'
export const SET_ASSESSMENT_FILTERS = 'SET_ASSESSMENT_FILTERS'
export const SET_INSTITUTE_DOMAIN = 'SET_INSTITUTE_DOMAIN'
export const SET_INSTITUTE_DEGREE = 'SET_INSTITUTE_DEGREE'
export const SET_INSTITUTE_DEPARTMENT = 'SET_INSTITUTE_DEPARTMENT'
export const SET_INSTITUTE_SPECIALIZATION = 'SET_INSTITUTE_SPECIALIZATION'
export const SET_STUDENT_DATA_SENT = 'SET_STUDENT_DATA_SENT'
export const SET_STUDENT_DATA_PENDING = 'SET_STUDENT_DATA_PENDING'
export const SET_STUDENT_DATA_IN_PROGRESS = 'SET_STUDENT_DATA_IN_PROGRESS'
export const SET_STUDENT_DATA_DROPPED_OFF = 'SET_STUDENT_DATA_DROPPED_OFF'
export const SET_STUDENT_DATA_COMPLETED = 'SET_STUDENT_DATA_COMPLETED'
export const SET_STUDENT_DATA_LOADING = 'SET_STUDENT_DATA_LOADING'
export const SET_STUDENT_DATA_PAGINATION = 'SET_STUDENT_DATA_PAGINATION'
export const SCHEDULE_ASSESSMENTS_REQUEST = 'SCHEDULE_ASSESSMENTS_REQUEST'
export const SCHEDULE_ASSESSMENTS_SUCCESS = 'SCHEDULE_ASSESSMENTS_SUCCESS'
export const SCHEDULE_ASSESSMENTS_FAILURE = 'SCHEDULE_ASSESSMENTS_FAILURE'
export const UPDATE_SCHEDULE_ASSESSMENT_REQUEST = 'UPDATE_SCHEDULE_ASSESSMENT_REQUEST'
export const UPDATE_SCHEDULE_ASSESSMENT_SUCCESS = 'UPDATE_SCHEDULE_ASSESSMENT_SUCCESS'
export const UPDATE_SCHEDULE_ASSESSMENT_FAILURE = 'UPDATE_SCHEDULE_ASSESSMENT_FAILURE'
export const GET_SCHEDULE_ASSESSMENT_REQUEST = 'GET_SCHEDULE_ASSESSMENT_REQUEST'
export const GET_SCHEDULE_ASSESSMENT_SUCCESS = 'GET_SCHEDULE_ASSESSMENT_SUCCESS'
export const GET_SCHEDULE_ASSESSMENT_FAILURE = 'GET_SCHEDULE_ASSESSMENT_FAILURE'
export const SET_ASSESSMENT_CREATION_DATA = 'SET_ASSESSMENT_CREATION_DATA'
export const ADD_BULK_UPLOAD_DATA = 'ADD_BULK_UPLOAD_DATA'
export const CLEAR_ASSESSMENT_CREATION_DATA = 'CLEAR_ASSESSMENT_CREATION_DATA'
export const REMOVE_ASSESSMENT = 'REMOVE_ASSESSMENT'
// Add this to your action types at the top of the file
export const SEND_REMINDERS_REQUEST = 'SEND_REMINDERS_REQUEST'
export const SEND_REMINDERS_SUCCESS = 'SEND_REMINDERS_SUCCESS'
export const SEND_REMINDERS_FAILURE = 'SEND_REMINDERS_FAILURE'
export const RESEND_INVITES_REQUEST = 'RESEND_INVITES_REQUEST'
export const RESEND_INVITES_SUCCESS = 'RESEND_INVITES_SUCCESS'
export const RESEND_INVITES_FAILURE = 'RESEND_INVITES_FAILURE'
export const SET_SUBSCRIPTION_STATES = 'SET_SUBSCRIPTION_STATES'
export const SET_SUBSCRIPTION_CITIES = 'SET_SUBSCRIPTION_CITIES'
export const SET_SUBSCRIPTION_INSTITUTES = 'SET_SUBSCRIPTION_INSTITUTES'
export const ASSIGN_SUBSCRIPTION_REQUEST = 'ASSIGN_SUBSCRIPTION_REQUEST'
export const ASSIGN_SUBSCRIPTION_SUCCESS = 'ASSIGN_SUBSCRIPTION_SUCCESS'
export const ASSIGN_SUBSCRIPTION_FAILURE = 'ASSIGN_SUBSCRIPTION_FAILURE'
export const SET_CORPORATE_COMPANIES = 'SET_CORPORATE_COMPANIES'
export const SET_CORPORATE_STATES = 'SET_CORPORATE_STATES'
export const SET_CORPORATE_CITIES = 'SET_CORPORATE_CITIES'
export const SET_ASSESSMENT_CORPORATE_STATES = 'SET_ASSESSMENT_CORPORATE_STATES'
export const SET_ASSESSMENT_CORPORATE_CITIES = 'SET_ASSESSMENT_CORPORATE_CITIES'
export const SET_ASSESSMENT_CORPORATE_COMPANIES =
  'SET_ASSESSMENT_CORPORATE_COMPANIES'
export const GENERATE_ROLE_BASED_QUESTIONS_REQUEST = 'GENERATE_ROLE_BASED_QUESTIONS_REQUEST';
export const GENERATE_ROLE_BASED_QUESTIONS_SUCCESS = 'GENERATE_ROLE_BASED_QUESTIONS_SUCCESS';
export const GENERATE_ROLE_BASED_QUESTIONS_FAILURE = 'GENERATE_ROLE_BASED_QUESTIONS_FAILURE';
export const ASSIGN_ROLE_BASED_ASSESSMENT_REQUEST = 'ASSIGN_ROLE_BASED_ASSESSMENT_REQUEST';
export const ASSIGN_ROLE_BASED_ASSESSMENT_SUCCESS = 'ASSIGN_ROLE_BASED_ASSESSMENT_SUCCESS';
export const ASSIGN_ROLE_BASED_ASSESSMENT_FAILURE = 'ASSIGN_ROLE_BASED_ASSESSMENT_FAILURE';

export const GENERATE_HINGLISH_QUESTIONS_REQUEST = 'GENERATE_HINGLISH_QUESTIONS_REQUEST';
export const GENERATE_HINGLISH_QUESTIONS_SUCCESS = 'GENERATE_HINGLISH_QUESTIONS_SUCCESS';
export const GENERATE_HINGLISH_QUESTIONS_FAILURE = 'GENERATE_HINGLISH_QUESTIONS_FAILURE';
// Aliases for unified naming
export const GENERATE_TOPIC_BASED_QUESTIONS_REQUEST = GENERATE_HINGLISH_QUESTIONS_REQUEST;
export const GENERATE_TOPIC_BASED_QUESTIONS_SUCCESS = GENERATE_HINGLISH_QUESTIONS_SUCCESS;
export const GENERATE_TOPIC_BASED_QUESTIONS_FAILURE = GENERATE_HINGLISH_QUESTIONS_FAILURE;

export const ASSIGN_AI_INTERVIEW_REQUEST = 'ASSIGN_AI_INTERVIEW_REQUEST';
export const ASSIGN_AI_INTERVIEW_SUCCESS = 'ASSIGN_AI_INTERVIEW_SUCCESS';
export const ASSIGN_AI_INTERVIEW_FAILURE = 'ASSIGN_AI_INTERVIEW_FAILURE';

// Assessment states (KPI data) action types
export const FETCH_ASSESSMENT_STATES_REQUEST = 'FETCH_ASSESSMENT_STATES_REQUEST'
export const FETCH_ASSESSMENT_STATES_SUCCESS = 'FETCH_ASSESSMENT_STATES_SUCCESS'
export const FETCH_ASSESSMENT_STATES_FAILURE = 'FETCH_ASSESSMENT_STATES_FAILURE'

// TPO Student List action types
export const FETCH_TPO_STUDENT_LIST_REQUEST = 'FETCH_TPO_STUDENT_LIST_REQUEST'
export const FETCH_TPO_STUDENT_LIST_SUCCESS = 'FETCH_TPO_STUDENT_LIST_SUCCESS'
export const FETCH_TPO_STUDENT_LIST_FAILURE = 'FETCH_TPO_STUDENT_LIST_FAILURE'

// Chart data action types
export const FETCH_ASSESSMENT_CHARTS_REQUEST = 'FETCH_ASSESSMENT_CHARTS_REQUEST'
export const FETCH_ASSESSMENT_CHARTS_SUCCESS = 'FETCH_ASSESSMENT_CHARTS_SUCCESS'
export const FETCH_ASSESSMENT_CHARTS_FAILURE = 'FETCH_ASSESSMENT_CHARTS_FAILURE'

// Chart filter action types
export const SET_CHART_FILTERS = 'SET_CHART_FILTERS'
export const CLEAR_CHART_FILTERS = 'CLEAR_CHART_FILTERS'



export const setAssessmentCorporateStates = states => ({
  type: SET_ASSESSMENT_CORPORATE_STATES,
  states,
})

export const setAssessmentCorporateCities = cities => ({
  type: SET_ASSESSMENT_CORPORATE_CITIES,
  cities,
})

export const setAssessmentCorporateCompanies = companies => ({
  type: SET_ASSESSMENT_CORPORATE_COMPANIES,
  companies,
})

export const setCorporateStates = states => ({
  type: SET_CORPORATE_STATES,
  states,
})

export const setCorporateCities = cities => ({
  type: SET_CORPORATE_CITIES,
  cities,
})

export const setCorporateCompanies = companies => ({
  type: SET_CORPORATE_COMPANIES,
  companies,
})

export const resendInvitesRequest = () => ({
  type: RESEND_INVITES_REQUEST,
})

export const resendInvitesSuccess = message => ({
  type: RESEND_INVITES_SUCCESS,
  message,
})

export const resendInvitesFailure = error => ({
  type: RESEND_INVITES_FAILURE,
  error,
})

export const sendRemindersRequest = () => ({
  type: SEND_REMINDERS_REQUEST,
})

export const sendRemindersSuccess = message => ({
  type: SEND_REMINDERS_SUCCESS,
  message,
})

export const sendRemindersFailure = error => ({
  type: SEND_REMINDERS_FAILURE,
  error,
})

export const removeAssessment = assessmentId => ({
  type: REMOVE_ASSESSMENT,
  assessmentId,
})

export const setSubscribedInstitutes = data => ({
  type: SET_SUBSCRIBED_INSTITUTES,
  data,
})

export const updatePage = page => ({
  type: UPDATE_PAGE,
  page,
})

export const setSelectedInstitute = data => ({
  type: SET_SELECTED_INSTITUTE,
  data,
})

export const setSubscriptionRenewalInstitutes = data => ({
  type: SET_SUBSCRIPTION_RENEWAL_INSTITUTES,
  data,
})

export const setLoading = status => ({
  type: SET_LOADING,
  status,
})

export const setError = error => ({
  type: SET_ERROR,
  error,
})

export const setSubscribedInstitutesPagination = pagination => ({
  type: SET_SUBSCRIBED_INSTITUTES_PAGINATION,
  pagination,
})

export const setSubscriptionRenewalPagination = pagination => ({
  type: SET_SUBSCRIPTION_RENEWAL_PAGINATION,
  pagination,
})

export const setTotalCollegeCount = count => ({
  type: SET_TOTAL_COLLEGE_COUNT,
  count,
})

export const setActiveAssessmentCount = count => ({
  type: SET_ACTIVE_ASSESSMENT_COUNT,
  count,
})

export const setSubscribedInstitutes_Subscribed_Count = count => ({
  type: SET_SUBSCRIBED_INSTITUTES_SUBSCRIBED_COUNT,
  count,
})

export const setSubscribedInstitutes_Trial_Count = count => ({
  type: SET_SUBSCRIBED_INSTITUTES_TRIAL_COUNT,
  count,
})

export const setSubscriptionRenewal_Subscribed_Count = count => ({
  type: SET_SUBSCRIPTION_RENEWAL_SUBSCRIBED_COUNT,
  count,
})

export const setSubscriptionRenewal_Trial_Count = count => ({
  type: SET_SUBSCRIPTION_RENEWAL_TRIAL_COUNT,
  count,
})

export const setFilters = filters => ({
  type: SET_FILTERS,
  filters,
})

export const resetFilters = () => ({
  type: RESET_FILTERS,
})

export const resetState = () => ({
  type: RESET_STATE,
})

export const setInstitutesStates = states => ({
  type: SET_INSTITUTES_STATES,
  states,
})

export const setInstitutesCities = cities => ({
  type: SET_INSTITUTES_CITIES,
  cities,
})

export const setInstitutesByCity = institutes => ({
  type: SET_INSTITUTES_BY_CITY,
  institutes,
})

export const setAssessmentByInstitute = assessments => ({
  type: SET_ASSESSMENT_BY_INSTITUTE,
  assessments,
})

export const setAssessmentSentCount = count => ({
  type: SET_ASSESSMENT_SENT_COUNT,
  count,
})

export const setAssessmentCompletedCount = count => ({
  type: SET_ASSESSMENT_COMPLETED_COUNT,
  count,
})

export const setDegreeSearchResults = data => ({
  type: SET_DEGREE_SEARCH_RESULTS,
  data,
})

export const setDegreeSearchLoading = status => ({
  type: SET_DEGREE_SEARCH_LOADING,
  status,
})

export const setDegreeSearchError = error => ({
  type: SET_DEGREE_SEARCH_ERROR,
  error,
})

export const setDegreeSelection = data => ({
  type: SET_DEGREE_SELECTION,
  data,
})

export const setRecentActivityLogs = logs => ({
  type: SET_RECENT_ACTIVITY_LOGS,
  logs,
})

export const setActiveAssessments = assessments => ({
  type: SET_ACTIVE_ASSESSMENTS,
  assessments,
})

export const setCompletedAssessments = assessments => ({
  type: SET_COMPLETED_ASSESSMENTS,
  assessments,
})

export const setActiveAssessmentsPagination = pagination => ({
  type: SET_ACTIVE_ASSESSMENTS_PAGINATION,
  pagination,
})

export const setCompletedAssessmentsPagination = pagination => ({
  type: SET_COMPLETED_ASSESSMENTS_PAGINATION,
  pagination,
})

export const setActiveAssessmentsMetrics = metrics => ({
  type: SET_ACTIVE_ASSESSMENTS_METRICS,
  metrics,
})
export const scheduleAssessmentsRequest = () => ({
  type: SCHEDULE_ASSESSMENTS_REQUEST,
});

export const scheduleAssessmentsSuccess = (message) => ({
  type: SCHEDULE_ASSESSMENTS_SUCCESS,
  payload: message,
});

export const scheduleAssessmentsFailure = (error) => ({
  type: SCHEDULE_ASSESSMENTS_FAILURE,
  payload: error,
});
export const setCompletedAssessmentsMetrics = metrics => ({
  type: SET_COMPLETED_ASSESSMENTS_METRICS,
  metrics,
})

// Add these action creators with the other action creators

export const setAssessmentFilters = filters => ({
  type: SET_ASSESSMENT_FILTERS,
  filters,
})

export const setInstituteDomain = domains => ({
  type: SET_INSTITUTE_DOMAIN,
  domains,
})

export const setInstituteDegree = degrees => ({
  type: SET_INSTITUTE_DEGREE,
  degrees,
})

export const setInstituteDepartment = departments => ({
  type: SET_INSTITUTE_DEPARTMENT,
  departments,
})

export const setInstituteSpecialization = specializations => ({
  type: SET_INSTITUTE_SPECIALIZATION,
  specializations,
})

export const setStudentDataSent = students => ({
  type: SET_STUDENT_DATA_SENT,
  students,
})

export const setStudentDataPending = students => ({
  type: SET_STUDENT_DATA_PENDING,
  students,
})

export const setStudentDataInProgress = students => ({
  type: SET_STUDENT_DATA_IN_PROGRESS,
  students,
})

export const setStudentDataDroppedOff = students => ({
  type: SET_STUDENT_DATA_DROPPED_OFF,
  students,
})

export const setStudentDataCompleted = students => ({
  type: SET_STUDENT_DATA_COMPLETED,
  students,
})

export const setStudentDataLoading = status => ({
  type: SET_STUDENT_DATA_LOADING,
  status,
})
export const setStudentDataPagination = pagination => ({
  type: SET_STUDENT_DATA_PAGINATION,
  pagination,
})
export const setAssessmentCreationData = data => ({
  type: SET_ASSESSMENT_CREATION_DATA,
  data,
})

export const addBulkUploadData = (assessmentId, uploadData) => ({
  type: ADD_BULK_UPLOAD_DATA,
  assessmentId,
  uploadData: uploadData.map(student => ({
    ...student,
    primary_email: student.email || student.primary_email, // ✅ Ensure primary_email is stored
    email: student.email || student.primary_email, // ✅ Ensure email is stored
  })),
})

export const clearAssessmentCreationData = () => ({
  type: CLEAR_ASSESSMENT_CREATION_DATA,
})

export const setSubscriptionStates = states => ({
  type: SET_SUBSCRIPTION_STATES,
  states,
})

export const setSubscriptionCities = cities => ({
  type: SET_SUBSCRIPTION_CITIES,
  cities,
})
export const SET_ASSESSMENT_INFO = 'SET_ASSESSMENT_INFO'
export const setAssessmentInfo = assessmentInfo => ({
  type: SET_ASSESSMENT_INFO,
  assessmentInfo,
})

// Email + candidate-journey counts for the assessment detail funnel. Kept
// separate from assessmentInfo because it comes from the tracking tables rather
// than the assessment record, and is absent for campaigns that predate tracking.
export const SET_DELIVERY_FUNNEL = 'SET_DELIVERY_FUNNEL'
export const setDeliveryFunnel = deliveryFunnel => ({
  type: SET_DELIVERY_FUNNEL,
  deliveryFunnel,
})

export const setSubscriptionInstitutes = institutes => ({
  type: SET_SUBSCRIPTION_INSTITUTES,
  institutes,
})
export const fetchAptitudeTopicsRequest = () => ({
  type: FETCH_APTITUDE_TOPICS_REQUEST,
})

export const fetchAptitudeTopicsSuccess = topics => ({
  type: FETCH_APTITUDE_TOPICS_SUCCESS,
  payload: topics,
})

export const fetchAptitudeTopicsFailure = error => ({
  type: FETCH_APTITUDE_TOPICS_FAILURE,
  payload: error,
})

export const assignSubscriptionRequest = () => ({
  type: ASSIGN_SUBSCRIPTION_REQUEST,
})

export const assignSubscriptionSuccess = message => ({
  type: ASSIGN_SUBSCRIPTION_SUCCESS,
  message,
})

export const assignSubscriptionFailure = error => ({
  type: ASSIGN_SUBSCRIPTION_FAILURE,
  error,
})

let fetchStudentsByStatusController = null

export const fetchStudentsByStatus =
  (assessmentId, status, entityType = 'college', search = '', pageNo = 0, pageLimit = 10, filters = {}, paginate = false) =>
    async dispatch => {
      if (fetchStudentsByStatusController) {
        fetchStudentsByStatusController.abort()
      }
      const controller = new AbortController()
      fetchStudentsByStatusController = controller

      dispatch(setStudentDataLoading(true))

      try {
        // Forward CandidateList filters (degree/department/specialization/status)
        // to the server. getAssessmentDetails applies them in SQL, so pagination
        // and counts stay correct.
        const serverFilters = {}
        if (filters.degree?.length) serverFilters.degree = filters.degree
        if (filters.department?.length) serverFilters.department = filters.department
        if (filters.specialization?.length) serverFilters.specialization = filters.specialization
        if (filters.status?.length) serverFilters.status = filters.status

        const response = await adminRequest.get(
          '/assessment/getAssessmentDetails',
          {
            params: {
              assessmentInstituteMapID: assessmentId,
              entityType,
              searchQuery: search,
              pageNo,
              pageLimit,
              ...(paginate ? { paginate: true } : {}),
              ...(Object.keys(serverFilters).length
                ? { filters: JSON.stringify(serverFilters) }
                : {}),
            },
            signal: controller.signal,
          }
        )

        const studentData = response.data.data.studentData || {}
        const pagination = response.data.data.pagination || {}

        const assessmentInfo = response.data.data.assessmentInfo || {}
        dispatch(setAssessmentInfo(assessmentInfo))

        dispatch(setStudentDataSent(studentData.sent || []))
        dispatch(setStudentDataPending(studentData.pending || []))
        dispatch(setStudentDataInProgress(studentData.inProgress || []))
        dispatch(setStudentDataDroppedOff(studentData.droppedOff || []))
        dispatch(setStudentDataCompleted(studentData.completed || []))
        dispatch(setStudentDataPagination(pagination))

        return studentData
      } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError' || error.code === 'ERR_CANCELED') {
          return []
        }
        console.error('Error fetching student data:', error)
        dispatch(setError(error.message || 'Failed to fetch student data'))
        return []
      } finally {
        if (fetchStudentsByStatusController === controller) {
          fetchStudentsByStatusController = null
          dispatch(setStudentDataLoading(false))
        }
      }
    }

// Update fetchAllStudentStatusCounts to also store assessment info
export const fetchAllStudentStatusCounts =
  (assessmentId, entityType = 'college') =>
    async dispatch => {
      dispatch(setStudentDataLoading(true))

      try {
        // Make single API call to get assessment details with entityType
        const response = await adminRequest.get(
          '/assessment/getAssessmentDetails',
          {
            params: {
              assessmentInstituteMapID: assessmentId,
              entityType,
            },
          }
        )

        // Extract student data from response
        const studentData = response.data.data.studentData || {}

        // Extract and store assessment info (including CEFR level)
        const assessmentInfo = response.data.data.assessmentInfo || {}
        dispatch(setAssessmentInfo(assessmentInfo))
        dispatch(setDeliveryFunnel(response.data.data.deliveryFunnel || null))

        // Dispatch actions for each status type
        dispatch(setStudentDataSent(studentData.sent || []))
        dispatch(setStudentDataPending(studentData.pending || []))
        dispatch(setStudentDataInProgress(studentData.inProgress || []))
        dispatch(setStudentDataDroppedOff(studentData.droppedOff || []))
        dispatch(setStudentDataCompleted(studentData.completed || []))

        return studentData
      } catch (error) {
        console.error('Error fetching student status counts:', error)
        dispatch(
          setError(error.message || 'Failed to fetch student status counts')
        )
        return {}
      } finally {
        dispatch(setStudentDataLoading(false))
      }
    }
// Update exportStudentData to handle entityType
export const exportStudentData =
  (assessmentId, entityType = 'college', status = 'completed', options = {}) =>
    async dispatch => {
      dispatch(setStudentDataLoading(true))

      try {
        // Reflect the on-screen CandidateList filters in the export.
        const serverFilters = {}
        if (options.degree?.length) serverFilters.degree = options.degree
        if (options.department?.length) serverFilters.department = options.department
        if (options.specialization?.length) serverFilters.specialization = options.specialization
        if (options.status?.length) serverFilters.status = options.status

        // Make API call to get excel file with entityType + status bucket
        const response = await adminRequest.get('/assessment/exportStudentData', {
          params: {
            assessmentInstituteMapID: assessmentId,
            entityType,
            status,
            ...(options.search ? { searchQuery: options.search } : {}),
            ...(Object.keys(serverFilters).length
              ? { filters: JSON.stringify(serverFilters) }
              : {}),
          },
          responseType: 'blob', // Important: This tells axios to handle as binary data
        })

        // Create a URL for the blob
        const url = window.URL.createObjectURL(new Blob([response.data]))

        // Create a link element to trigger download
        const link = document.createElement('a')
        link.href = url

        // Set the filename from Content-Disposition header or fallback to default
        const contentDisposition = response.headers['content-disposition']
        let filename = 'student-data.xlsx'

        if (contentDisposition) {
          const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
          const matches = filenameRegex.exec(contentDisposition)
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, '')
          }
        } else {
          // Generate filename based on status and date if header not available
          filename = `Results-${new Date().toISOString().split('T')[0]}.xlsx`
        }

        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()

        // Clean up
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)

        return true
      } catch (error) {
        console.error('Error exporting student data:', error)
        dispatch(setError(error.message || 'Failed to export student data'))
        return false
      } finally {
        dispatch(setStudentDataLoading(false))
      }
    }
export const fetchAptitudeTopics = () => async dispatch => {
  dispatch({ type: FETCH_APTITUDE_TOPICS_REQUEST })

  try {
    // Replace this with your actual API endpoint
    const response = await adminRequest.get('/assessment/getAptitudeTopics')

    // Extract the data array from the response
    const aptitudeTopicsData = response.data.data || response.data

    console.log('API Response:', response.data) // Debug log
    console.log('Dispatching data:', aptitudeTopicsData) // Debug log

    dispatch({
      type: FETCH_APTITUDE_TOPICS_SUCCESS,
      payload: aptitudeTopicsData // This should be the array of sections
    })

    return aptitudeTopicsData
  } catch (error) {
    console.error('Error fetching aptitude topics:', error)
    dispatch({
      type: FETCH_APTITUDE_TOPICS_FAILURE,
      payload: error.message
    })
    throw error
  }
}

// Fetch the aptitude configuration (section split / active topics / difficulty
// mix per length) used by the institute "Assessment Configuration" panel.
// Cached: once loaded it is reused, so difficulty toggles never re-request.
export const fetchAptitudeConfig = () => async (dispatch, getState) => {
  const cached = getState()?.SubscribedInstitutes?.aptitudeConfig?.data
  if (cached && Object.keys(cached).length > 0) {
    return cached
  }

  dispatch({ type: FETCH_APTITUDE_CONFIG_REQUEST })
  try {
    const response = await adminRequest.get('/assessment/getAptitudeConfig')
    const data = response.data?.data || response.data
    dispatch({ type: FETCH_APTITUDE_CONFIG_SUCCESS, payload: data })
    return data
  } catch (error) {
    console.error('Error fetching aptitude config:', error)
    dispatch({ type: FETCH_APTITUDE_CONFIG_FAILURE, payload: error.message })
  }
}
// Ask the API whether a paper can actually be built from the selected topics at
// the chosen difficulty. Not cached and not stored in redux — it is a per-form
// answer that goes stale the moment the selection or difficulty changes, so the
// caller holds it. Resolves to the availability payload, or null on failure
// (a pre-flight that cannot run must never block the admin).
export const checkAptitudeTopicAvailability =
  ({ aptitudeTypes, subtopics, difficultySettings }) =>
    async () => {
      try {
        const response = await adminRequest.post(
          '/assessment/aptitudeTopicAvailability',
          { aptitudeTypes, subtopics, difficultySettings }
        )
        return response.data?.data || response.data
      } catch (error) {
        const apiMessage = error?.response?.data?.message
        console.error('Error checking aptitude topic availability:', apiMessage || error.message)
        return apiMessage ? { canGenerate: false, message: apiMessage, shortfalls: [] } : null
      }
    }

// Update sendRemindersToStudents to handle entityType and selected students
export const sendRemindersToStudents =
  (assessmentId, entityType = 'college', selectedStudents = null) =>
    async dispatch => {
      dispatch(sendRemindersRequest())

      try {
        // Prepare request payload
        const payload = {
          assessmentInstituteMapID: assessmentId,
          entityType,
        }

        // Add selected students if provided
        if (selectedStudents && selectedStudents.length > 0) {
          payload.selectedStudents = selectedStudents
        }

        // Call API endpoint to send reminders with entityType and optionally selected students
        const response = await adminRequest.post('/assessment/sendReminders', payload)

        // //console.log('Reminders sent successfully', response.data)

        dispatch(
          sendRemindersSuccess(
            response.data.message || 'Reminders sent successfully'
          )
        )
        return true
      } catch (error) {
        console.error('Error sending reminders:', error)
        dispatch(
          sendRemindersFailure(error.message || 'Failed to send reminders')
        )
        return false
      }
    }

// Update resendInvitesToStudents to handle entityType and selected students
export const resendInvitesToStudents =
  (assessmentId, entityType = 'college', selectedStudents = null) =>
    async dispatch => {
      dispatch(resendInvitesRequest())

      try {
        // Prepare request payload
        const payload = {
          assessmentInstituteMapID: assessmentId,
          entityType,
        }

        // Add selected students if provided
        if (selectedStudents && selectedStudents.length > 0) {
          payload.selectedStudents = selectedStudents
        }

        // Call API endpoint to resend invites with entityType and optionally selected students
        const response = await adminRequest.post('/assessment/resendInvites', payload)

        // //console.log('Invites resent successfully', response.data)

        dispatch(
          resendInvitesSuccess(
            response.data.message || 'Invites resent successfully'
          )
        )
        return true
      } catch (error) {
        console.error('Error resending invites:', error)
        dispatch(
          resendInvitesFailure(error.message || 'Failed to resend invites')
        )
        return false
      }
    }

export const updateDegreeSelection =
  (checked, type, degreeId, streamId, specId) => (dispatch, getState) => {
    const currentResults = selectDegreeSearchResults(getState())
    let updatedResults = [...currentResults]

    switch (type) {
      case 'allDegree':
        updatedResults = updatedResults.map(degree => ({
          ...degree,
          isSelected: checked,
          streams: degree.streams?.map(stream => ({
            ...stream,
            isSelected: checked,
            specializations: stream.specializations?.map(spec => ({
              ...spec,
              isSelected: checked,
            })),
          })),
        }))
        break

      case 'allStream':
        updatedResults = updatedResults.map(degree => ({
          ...degree,
          streams: degree.streams?.map(stream => ({
            ...stream,
            isSelected: checked,
            specializations: stream.specializations?.map(spec => ({
              ...spec,
              isSelected: checked,
            })),
          })),
        }))
        break

      case 'allSpec':
        updatedResults = updatedResults.map(degree => ({
          ...degree,
          streams: degree.streams?.map(stream => ({
            ...stream,
            specializations: stream.specializations?.map(spec => ({
              ...spec,
              isSelected: checked,
            })),
          })),
        }))
        break

      case 'degree':
        updatedResults = updatedResults.map(degree => {
          if (degree.degreeId === degreeId) {
            return {
              ...degree,
              isSelected: checked,
              streams: degree.streams?.map(stream => ({
                ...stream,
                isSelected: checked,
                specializations: stream.specializations?.map(spec => ({
                  ...spec,
                  isSelected: checked,
                })),
              })),
            }
          }
          return degree
        })
        break

      case 'stream':
        updatedResults = updatedResults.map(degree => {
          if (degree.degreeId === degreeId) {
            return {
              ...degree,
              streams: degree.streams?.map(stream => {
                if (stream.streamId === streamId) {
                  return {
                    ...stream,
                    isSelected: checked,
                    specializations: stream.specializations?.map(spec => ({
                      ...spec,
                      isSelected: checked,
                    })),
                  }
                }
                return stream
              }),
            }
          }
          return degree
        })
        break

      case 'specialisation':
        updatedResults = updatedResults.map(degree => {
          if (degree.degreeId === degreeId) {
            return {
              ...degree,
              streams: degree.streams?.map(stream => {
                if (stream.streamId === streamId) {
                  return {
                    ...stream,
                    specializations: stream.specializations?.map(spec => {
                      if (spec.id === specId) {
                        return {
                          ...spec,
                          isSelected: checked,
                        }
                      }
                      return spec
                    }),
                  }
                }
                return stream
              }),
            }
          }
          return degree
        })
        break
    }

    dispatch(setDegreeSelection(updatedResults))
  }




export const fetchActiveAssessments =
  (params = {}) =>
    async (dispatch, getState) => {
      dispatch(setLoading(true))
      // Latest-wins: see latestRequest.js — a slower earlier request must not
      // overwrite the list the current tab asked for.
      const ticket = latestRequest('activeAssessments')


      try {
        const state = getState()
        const currentFilters = state.SubscribedInstitutes.filters
        const queryParams = {
          pageNo: params.pageNo ?? currentFilters.pageNo ?? 0,
          pageLimit: params.pageLimit ?? currentFilters.pageLimit ?? 10,
          searchBy: params.searchBy ?? currentFilters.searchBy ?? '',
          // Default sort: newest-created first. Backend maps 'createdAt' to
          // COALESCE(audit.createdat, start_time) — see admin-node getActiveAssessments.
          order: params.order ?? currentFilters.order ?? 'createdAt',
          sort: params.sort ?? currentFilters.sort ?? 'desc',
          type_name: params.type_name ?? currentFilters.type_name ?? '',
          isTrial: params.isTrial ?? currentFilters.isTrial ?? false,
          isSubscribed:
            params.isSubscribed ?? currentFilters.isSubscribed ?? false,
          states: params.states ?? currentFilters.states ?? [],
          cities: params.cities ?? currentFilters.cities ?? [],
          entityType: params.entityType ?? currentFilters.entityType ?? 'college',
          instituteId: params.instituteId ?? currentFilters.instituteId ?? null,
        }

        // Create serialized params for API request
        const apiParams = {
          ...queryParams,
          states: queryParams.states?.length
            ? queryParams.states.join(',')
            : undefined,
          cities: queryParams.cities?.length
            ? queryParams.cities.join(',')
            : undefined,

        }

        // Update filters in Redux store
        if (params.updateFilters) {
          dispatch(
            setFilters({ ...queryParams, entityType: queryParams.entityType })
          )
        }

        // Update page separately if only page changed
        if (params.pageOnly) {
          dispatch(updatePage(params.pageNo))
        }


        console.log('apiParams for asssess count ---------- :', apiParams)

        // Use the same endpoint and pass entityType as a parameter
        const response = await adminRequest.get(
          '/assessment/getActiveAssessments',
          {
            params: apiParams,
            paramsSerializer: params => {
              return qs.stringify(params, { arrayFormat: 'comma' })
            },
          }
        )

        // Process response
        const responseData = response.data.data
        if (!ticket.isLatest()) {
          return responseData
        }

        dispatch(setActiveAssessments(responseData.data))
        dispatch(
          setActiveAssessmentsPagination({
            page: parseInt(responseData.page) || 0,
            limit: parseInt(responseData.limit) || 10,
            totalItems: responseData.count || 0,
            currentCount: responseData.currentCount || 0,
            totalPages: parseInt(responseData.totalPages) || 1,
            stateCityPairs: responseData.stateCityPairs || [],
          })
        )

        dispatch(
          setActiveAssessmentsMetrics({
            total: responseData.count || 0,
            completed: responseData.data.reduce(
              (acc, curr) => acc + (curr.assessmentCompleted || 0),
              0
            ),
            pending: responseData.data.reduce(
              (acc, curr) =>
                acc +
                ((curr.assessmentSent || 0) - (curr.assessmentCompleted || 0)),
              0
            ),
            trialCount: responseData.trialCount || 0,
            subscribedCount: responseData.subscribedCount || 0,
          })
        )

        return responseData
      } catch (error) {
        console.error('Error fetching active assessments:', error)
        dispatch(setError(error.message || 'Failed to fetch active assessments'))
        return []
      } finally {
        if (ticket.isLatest()) {
          dispatch(setLoading(false))
        }
      }
    }

export const fetchCompletedAssessments =
  (params = {}) =>
    async (dispatch, getState) => {
      dispatch(setLoading(true))
      // Latest-wins: see latestRequest.js — a slower earlier request must not
      // overwrite the list the current tab asked for.
      const ticket = latestRequest('completedAssessments')
      try {
        const state = getState()
        const currentFilters = state.SubscribedInstitutes.filters
        const queryParams = {
          pageNo: params.pageNo ?? currentFilters.pageNo ?? 0,
          pageLimit: params.pageLimit ?? currentFilters.pageLimit ?? 10,
          searchBy: params.searchBy ?? currentFilters.searchBy ?? '',
          order: params.order ?? currentFilters.order ?? 'endDate',
          sort: params.sort ?? currentFilters.sort ?? 'desc',
          type_name: params.type_name ?? currentFilters.type_name ?? '',
          isTrial: params.isTrial ?? currentFilters.isTrial ?? false,
          isSubscribed:
            params.isSubscribed ?? currentFilters.isSubscribed ?? false,
          states: params.states ?? currentFilters.states ?? [],
          cities: params.cities ?? currentFilters.cities ?? [],
          entityType: params.entityType ?? currentFilters.entityType ?? 'college',
        }

        // Create serialized params for API request
        const apiParams = {
          ...queryParams,
          states: queryParams.states?.length
            ? queryParams.states.join(',')
            : undefined,
          cities: queryParams.cities?.length
            ? queryParams.cities.join(',')
            : undefined,
        }

        // Update filters in Redux store
        if (params.updateFilters) {
          dispatch(
            setFilters({ ...queryParams, entityType: queryParams.entityType })
          )
        }

        // Update page separately if only page changed
        if (params.pageOnly) {
          dispatch(updatePage(params.pageNo))
        }

        // Use the same endpoint and pass entityType as a parameter
        const response = await adminRequest.get(
          '/assessment/getCompletedAssessments',
          {
            params: apiParams,
            paramsSerializer: params => {
              return qs.stringify(params, { arrayFormat: 'comma' })
            },
          }
        )

        // Process response
        const responseData = response.data.data
        if (!ticket.isLatest()) {
          return responseData
        }

        dispatch(setCompletedAssessments(responseData.data))
        dispatch(
          setCompletedAssessmentsPagination({
            page: parseInt(responseData.page) || 0,
            limit: parseInt(responseData.limit) || 10,
            totalItems: responseData.count || 0,
            currentCount: responseData.currentCount || 0,
            totalPages: parseInt(responseData.totalPages) || 1,
            stateCityPairs: responseData.stateCityPairs || [],
          })
        )

        dispatch(
          setCompletedAssessmentsMetrics({
            total: responseData.count || 0,
            completedOnTime: Math.floor(responseData.data.length * 0.7),
            completedLate:
              responseData.data.length -
              Math.floor(responseData.data.length * 0.7),
            trialCount: responseData.trialCount || 0,
            subscribedCount: responseData.subscribedCount || 0,
          })
        )

        return responseData
      } catch (error) {
        console.error('Error fetching completed assessments:', error)
        dispatch(
          setError(error.message || 'Failed to fetch completed assessments')
        )
        return []
      } finally {
        if (ticket.isLatest()) {
          dispatch(setLoading(false))
        }
      }
    }

export const getEligibilityCriteria =
  ({
    searchValue = '',
    searchType = 'ALL',
    searchField = [],
    degreeId = '',
    campusID = '',
    departmentId = '',
  }) =>
    async () => {
      const institute_id = campusID
      let filters = [
        {
          type: 'terms',
          field: 'instituteCampuseId',
          value: [institute_id],
        },
        degreeId && {
          type: 'terms',
          field: 'degreeId.keyword',
          value: [degreeId],
        },
        departmentId && {
          type: 'terms',
          field: 'streamId.keyword',
          value: [departmentId],
        },
        (searchType === 'DEGREE' || searchType === 'STREAM') && {
          field: 'courseStatus',
          value: 1,
        },
      ].filter(Boolean)

      let output = []

      if (searchField?.length > 0) {
        output = searchField?.map(value => ({
          field: 'type.keyword',
          value,
        }))
      }
      if (
        (searchValue && searchType == 'STREAM') ||
        searchType == 'SPECIALISATION'
      ) {
        searchValue = searchValue.toLowerCase()
      }
      let payLoad = systemConfig?.degree_streams_specialisation_course
      payLoad.q = searchValue || ''
      payLoad.searchType = searchType
      payLoad.filters = filters
      payLoad.should = output

      try {
        const result = await elasticSearchRequest.post(
          `/search/degrees/streams/specialisations/events`,
          payLoad
        )
        return result?.data?.data
      } catch (error) {
        ErrorMessage(error?.message)
      }
    }

// Update the total count function to include entity type
export const fetchTotalCollegeCount =
  (entityType = 'college') =>
    async dispatch => {
      dispatch(setLoading(true))
      try {
        const endpoint =
          entityType === 'corporate'
            ? '/assessment/getTotalCompanyCount'
            : '/assessment/getTotalCollegeCount'

        const response = await adminRequest.get(endpoint)
        dispatch(setTotalCollegeCount(response.data.data))
        return response.data
      } catch (error) {
        dispatch(setError(error.message))
        throw error
      } finally {
        dispatch(setLoading(false))
      }
    }

// Update active assessment count to include entity type
export const fetchActiveAssessmentCount =
  (entityType = 'college') =>
    async dispatch => {
      dispatch(setLoading(true))
      try {
        const response = await adminRequest.get(
          '/assessment/getActiveAssessmentCount',
          {
            params: { entityType },
          }
        )
        dispatch(setActiveAssessmentCount(response.data.data))
        return response.data
      } catch (error) {
        dispatch(setError(error.message))
        throw error
      } finally {
        dispatch(setLoading(false))
      }
    }

// Update assessment sent count to include entity type
export const fetchAssessmentSentCount =
  (entityType = 'college') =>
    async dispatch => {
      dispatch(setLoading(true))
      try {
        const response = await adminRequest.get(
          '/assessment/getAssessmentSentCount',
          {
            params: { entityType },
          }
        )
        dispatch(setAssessmentSentCount(response.data.data))
        return response.data
      } catch (error) {
        dispatch(setError(error.message))
        throw error
      } finally {
        dispatch(setLoading(false))
      }
    }

// Update completed assessment count to include entity type
export const fetchAssessmentCompletedCount =
  (entityType = 'college') =>
    async dispatch => {
      dispatch(setLoading(true))
      try {
        const response = await adminRequest.get(
          '/assessment/getAssessmentCompletedCount',
          {
            params: { entityType },
          }
        )
        dispatch(setAssessmentCompletedCount(response.data.data))
        return response.data
      } catch (error) {
        dispatch(setError(error.message))
        throw error
      } finally {
        dispatch(setLoading(false))
      }
    }

export const fetchSubscribedInstitutes =
  params => async (dispatch, getState) => {
    dispatch(setLoading(true))
    try {
      const state = getState()
      const currentFilters = state.SubscribedInstitutes.filters

      const queryParams = {
        pageNo: params.pageNo ?? currentFilters.pageNo ?? 0,
        pageLimit: params.pageLimit ?? currentFilters.pageLimit ?? 10,
        searchBy: params.searchBy ?? currentFilters.searchBy ?? '',
        order: params.order ?? currentFilters.order ?? 'endDate',
        sort: params.sort ?? currentFilters.sort ?? 'desc',
        type_name: params.type_name ?? currentFilters.type_name ?? '',
        isTrial: params.isTrial ?? currentFilters.isTrial ?? false,
        isSubscribed:
          params.isSubscribed ?? currentFilters.isSubscribed ?? false,
        states: params.states ?? currentFilters.states ?? [], // Keep as array
        cities: params.cities ?? currentFilters.cities ?? [], // Keep as array
      }

      // Create serialized params for API request
      const apiParams = {
        ...queryParams,
        states: queryParams.states?.length
          ? queryParams.states.join(',')
          : undefined,
        cities: queryParams.cities?.length
          ? queryParams.cities.join(',')
          : undefined,
      }

      const response = await adminRequest.get(
        '/assessment/getSubscribedInstitutes',
        {
          params: apiParams,
          paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'comma' })
          },
        }
      )

      // Update filters in Redux store
      if (params.updateFilters) {
        dispatch(setFilters(queryParams))
      }

      // Update page separately if only page changed
      if (params.pageOnly) {
        dispatch(updatePage(params.pageNo))
      }

      dispatch(
        setSubscribedInstitutes({
          data: response.data.data.data,
          subscribedCount: response.data.data.subscribedCount,
          trialCount: response.data.data.trialCount,
          count: response.data.data.count,
          currentCount: response.data.data.currentCount,
          page: response.data.data.page,
          limit: response.data.data.limit,
          totalPages: response.data.data.totalPages,
          stateCityPairs: response.data.data.stateCityPairs,
        })
      )

      return response.data
    } catch (error) {
      dispatch(setError(error.message))
      throw error
    } finally {
      dispatch(setLoading(false))
    }
  }

export const fetchSubscriptionRenewalInstitutes =
  params => async (dispatch, getState) => {
    dispatch(setLoading(true))
    try {
      const state = getState()
      const currentFilters = state.SubscribedInstitutes.filters

      const queryParams = {
        pageNo: params.pageNo ?? currentFilters.pageNo ?? 0,
        pageLimit: params.pageLimit ?? currentFilters.pageLimit ?? 10,
        searchBy: params.searchBy ?? currentFilters.searchBy ?? '',
        order: params.order ?? currentFilters.order ?? 'endDate',
        sort: params.sort ?? currentFilters.sort ?? 'desc',
        type_name: params.type_name ?? currentFilters.type_name ?? '',
        isTrial: params.isTrial ?? currentFilters.isTrial ?? false,
        isSubscribed:
          params.isSubscribed ?? currentFilters.isSubscribed ?? false,
        states: params.states ?? currentFilters.states ?? [], // Keep as array
        cities: params.cities ?? currentFilters.cities ?? [], // Keep as array
      }

      // Create serialized params for API request
      const apiParams = {
        ...queryParams,
        states: queryParams.states?.length
          ? queryParams.states.join(',')
          : undefined,
        cities: queryParams.cities?.length
          ? queryParams.cities.join(',')
          : undefined,
      }

      const response = await adminRequest.get(
        '/assessment/getSubscriptionRenewalInstitutes',
        {
          params: apiParams,
          paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'comma' })
          },
        }
      )

      // Update filters in Redux store
      if (params.updateFilters) {
        dispatch(setFilters(queryParams))
      }

      // Update page separately if only page changed
      if (params.pageOnly) {
        dispatch(updatePage(params.pageNo))
      }

      dispatch(
        setSubscriptionRenewalInstitutes({
          data: response.data.data.data,
          subscribedCount: response.data.data.subscribedCount,
          trialCount: response.data.data.trialCount,
          count: response.data.data.count,
          currentCount: response.data.data.currentCount,
          page: response.data.data.page,
          limit: response.data.data.limit,
          totalPages: response.data.data.totalPages,
          stateCityPairs: response.data.data.stateCityPairs,
        })
      )

      return response.data
    } catch (error) {
      dispatch(setError(error.message))
      throw error
    } finally {
      dispatch(setLoading(false))
    }
  }
export const fetchSpecificAssessmentStudentList = (instituteId, payload) => async dispatch => {
  dispatch({ type: FETCH_SPECIFIC_ASSESSMENT_STUDENT_LIST_REQUEST });
  try {
    const response = await studentRequest.post(
      `/students/assessments/tpo/specific-assessment-student-list/${instituteId}`,
      payload
    );
    dispatch({
      type: FETCH_SPECIFIC_ASSESSMENT_STUDENT_LIST_SUCCESS,
      payload: response.data.data
    });
    return response.data.data;
  } catch (error) {
    console.error('Error fetching specific student list:', error);
    dispatch({
      type: FETCH_SPECIFIC_ASSESSMENT_STUDENT_LIST_FAILURE,
      payload: error.message
    });
    throw error;
  }
};
export const fetchInstitutesStates = () => async dispatch => {
  dispatch(setLoading(true))
  try {
    const response = await adminRequest.get(
      '/assessment/getSubscribedInstituteStates'
    )
    dispatch(setInstitutesStates(response.data.data))
    return response.data
  } catch (error) {
    dispatch(setError(error.message))
    throw error
  } finally {
    dispatch(setLoading(false))
  }
}

export const fetchInstitutesCitiesByState = state => async dispatch => {
  dispatch(setLoading(true))
  try {
    const response = await adminRequest.get(
      '/assessment/getSubscribedInstituteCities',
      {
        params: { state },
      }
    )
    dispatch(setInstitutesCities(response.data.data))
    return response.data
  } catch (error) {
    dispatch(setError(error.message))
    throw error
  } finally {
    dispatch(setLoading(false))
  }
}

export const fetchInstitutesByCity = city => async dispatch => {
  dispatch(setLoading(true))
  try {
    const response = await adminRequest.get(
      '/assessment/getSubscribedInstitutesByCity',
      {
        params: { city },
      }
    )
    dispatch(setInstitutesByCity(response.data.data))
    return response.data
  } catch (error) {
    dispatch(setError(error.message))
    throw error
  } finally {
    dispatch(setLoading(false))
  }
}

export const fetchAssessmentsByEntity =
  (entityId, entityType = 'college') =>
    async dispatch => {
      dispatch(setLoading(true))
      try {
        // Determine the endpoint based on entity type
        const endpoint =
          entityType === 'college'
            ? '/assessment/getSubscribedAssessmentByInstitute'
            : '/assessment/getSubscribedAssessmentByCorporate'

        // Set up the params object with appropriate parameter name
        const params =
          entityType === 'college'
            ? { institute_id: entityId }
            : { corporate_id: entityId }

        const response = await adminRequest.get(endpoint, { params })

        // Dispatch the same action regardless of entity type
        dispatch(setAssessmentByInstitute(response.data.data.data))
        return response.data
      } catch (error) {
        dispatch(setError(error.message))
        throw error
      } finally {
        dispatch(setLoading(false))
      }
    }

export const fetchAssessmentCorporateStates = () => async dispatch => {
  dispatch(setLoading(true))
  try {
    const response = await adminRequest.get(
      '/assessment/getSubscribedCorporateStates'
    )
    dispatch(setAssessmentCorporateStates(response.data.data))
    return response.data.data
  } catch (error) {
    dispatch(setError(error.message))
    throw error
  } finally {
    dispatch(setLoading(false))
  }
}

export const fetchAssessmentCorporateCities = state => async dispatch => {
  dispatch(setLoading(true))
  try {
    const response = await adminRequest.get(
      '/assessment/getSubscribedCorporateCities',
      {
        params: { state },
      }
    )
    dispatch(setAssessmentCorporateCities(response.data.data))
    return response.data.data
  } catch (error) {
    dispatch(setError(error.message))
    throw error
  } finally {
    dispatch(setLoading(false))
  }
}

export const fetchAssessmentCorporateCompanies = city => async dispatch => {
  dispatch(setLoading(true))
  try {
    const response = await adminRequest.get(
      '/assessment/getSubscribedCorporateCompaniesByCity',
      {
        params: { city },
      }
    )
    dispatch(setAssessmentCorporateCompanies(response.data.data))
    return response.data.data
  } catch (error) {
    dispatch(setError(error.message))
    throw error
  } finally {
    dispatch(setLoading(false))
  }
}

export const fetchRecentActivityLogs = () => async dispatch => {
  dispatch(setLoading(true))
  try {
    const response = await adminRequest.get('/assessment/getTopActivityLogs')
    dispatch(setRecentActivityLogs(response.data.data))
    return response.data
  } catch (error) {
    dispatch(setError(error.message))
    throw error
  } finally {
    dispatch(setLoading(false))
  }
}
const mapSubtopicsForAPI = (assessmentType, subtopics, aptitudeTopicsData) => {
  if (!aptitudeTopicsData || !Array.isArray(aptitudeTopicsData)) {
    console.warn('No aptitude topics data available, using subtopics as-is')
    return subtopics
  }

  // Find the section that matches the assessment type
  const sectionMapping = {
    'logical_reasoning': 'Logical Reasoning',
    'critical_reasoning': 'Critical Reasoning',
    'quantitative': 'Quantitative'
  }

  const sectionName = sectionMapping[assessmentType]
  if (!sectionName) {
    console.warn(`No section mapping found for assessment type: ${assessmentType}`)
    return subtopics
  }

  // Find the matching section in the API data
  const section = aptitudeTopicsData.find(section =>
    section.sectionName.toLowerCase() === sectionName.toLowerCase()
  )

  if (!section || !section.topics) {
    console.warn(`No topics found for section: ${sectionName}`)
    return subtopics
  }

  // Create mapping from topic names to SubsectionIds
  const topicMapping = {}
  section.topics.forEach(topic => {
    topicMapping[topic.Name] = topic.SubsectionId
  })

  // Map subtopics to their SubsectionIds
  return subtopics.map(subtopic => {
    const mappedId = topicMapping[subtopic]
    if (!mappedId) {
      console.warn(`No mapping found for subtopic "${subtopic}" in ${sectionName}`)
      return subtopic // Return original if no mapping found
    }
    return mappedId
  })
}

export const filterAssessmentData = (assessmentData, aptitudeTopicsData = null) => {
  return assessmentData.map(assessment => {
    let selectedPaths = []

    // Process qualificationData if available
    if (assessment.qualificationData) {
      assessment.qualificationData.forEach(degree => {
        // If degree is selected, just add degree path and skip children
        if (degree.isSelected) {
          selectedPaths.push([degree.type, degree.degreeId, '', ''])
          return // Skip processing streams for this degree
        }

        // Process streams only if degree is not selected
        degree.streams?.forEach(stream => {
          // If stream is selected, add stream path and skip specializations
          if (stream.isSelected) {
            selectedPaths.push([
              degree.type,
              degree.degreeId,
              stream.streamId,
              '',
            ])
            return // Skip processing specializations for this stream
          }

          // Process specializations only if stream is not selected
          if (stream.specializations?.length > 0) {
            stream.specializations.forEach(spec => {
              if (spec.isSelected) {
                selectedPaths.push([
                  degree.type,
                  degree.degreeId,
                  stream.streamId,
                  spec.id,
                ])
              }
            })
          }
        })
      })
    }

    // ✅ Create base assessment object
    const baseAssessment = {
      entityId: assessment.entityId || assessment.collegeId,
      entityType: assessment.entityType || 'college',
      instructions: assessment.instructions || '',
      name: assessment.name,
      assessmentType: assessment.assessmentType,
      startDate: assessment.startDate,
      endDate: assessment.endDate,
      startTime: assessment.startTime,
      endTime: assessment.endTime,
      allowProctoring: assessment.allowProctoring || false,
      allowVerification: assessment.allowVerification !== false,
      selectedStreams: Array.isArray(assessment.selectedStreams)
        ? assessment.selectedStreams
        : assessment.selectedStreams
          ? [assessment.selectedStreams]
          : [],
      paths: selectedPaths,
      email: assessment.email || '',
      bulkUploadData: assessment.bulkUploadData || [],
      // Corporate-only OTP email-invite opt-in. Preserved here because this
      // function rebuilds the payload from a whitelist; otherwise the flag set
      // in CreateAssessment would be dropped before reaching assignAssessment.
      isOtpInvite: assessment.isOtpInvite || false,
    }

    // ✅ Handle assessment-specific fields
    if (assessment.assessmentType === 'Communication') {
      return {
        ...baseAssessment,
        cefrLevel: assessment.cefrLevel || 'B1',
        assessmentDomain: assessment.assessmentDomain || 'Universal',
        enabledSections: assessment.enabledSections || [],
        responseLanguage: assessment.responseLanguage || 'English',
        // Listening-audio accent (en-IN default). This whitelist rebuild would
        // otherwise strip the accent set in CreateAssessment, so the backend fell
        // back to en-IN and pool-picked an Indian set instead of generating the
        // selected accent (e.g. en-US) — same class of drop as isOtpInvite above.
        accent: assessment.accent || 'en-IN',
        generatedQuestions: assessment.generatedQuestions || null,
      }
    }
    if (assessment.assessmentType === 'Custom_Assessment') {
      // cfgMap is keyed by section_id. The original section name is stored
      // inside each value (alongside an optional user-overridden displayName).
      // We never look up by name — that ambiguity is exactly the bug this replaces.
      const cfgMap = assessment.customSectionConfig || {};

      const sectionConfigurations = Object.entries(cfgMap).map(([sectionId, config]) => ({
        section_id: sectionId,
        section_name: config.displayName || config.section_name || '',
        total_questions: config.numQuestions || 0,
        total_marks: config.totalMarks || 0,
        marks_per_question: config.marksPerQuestion || 0,
        section_time: config.sectionTime || 30,
      }));

      return {
        ...baseAssessment,
        sectionConfigurations,
      };
    }
    else if (assessment.assessmentType === 'Role_Based') {
      // ✅ CRITICAL FIX: Add Role-Based assessment handling
      console.log('Filtering Role-Based assessment:', assessment);
      return {
        ...baseAssessment,
        roleName: assessment.roleName || '',
        skills: assessment.selectedSkills || assessment.skills || [],
        seniority: assessment.seniority || 'fresher',
        jobDescription: assessment.jobDescription || '',
        industry_domain: assessment.industry_domain || '',
        region: assessment.region || 'India',
        generatedQuestions: assessment.generatedQuestions || null,
      }
    }
    else if (assessment.assessmentType === 'Behavior') {
      const stream = String(baseAssessment.selectedStreams[0] || '').toLowerCase();
      let assessmentDomain = assessment.assessmentDomain || '';
      if (!assessmentDomain) {
        if (stream === 'engineering' || stream === 'science') {
          assessmentDomain = 'Engineering';
        } else if (stream === 'management' || stream === 'commerce') {
          assessmentDomain = 'Management';
        }
      }
      return {
        ...baseAssessment,
        assessmentDomain,
      }
    }
    else if (['Cognitive', 'Tech_MCQ', 'Tech_Coding'].includes(assessment.assessmentType)) {
      return {
        ...baseAssessment,
        assessmentLink: assessment.assessmentLink || null,
      }
    }
    else if (assessment.assessmentType === 'Aptitude') {
      const mappedAptitudeSubtopics = assessment.aptitudeSubtopics
        ? mapSubtopicsForAPI(assessment.aptitudeType, assessment.aptitudeSubtopics, aptitudeTopicsData)
        : []

      console.log('Original aptitude subtopics:', assessment.aptitudeSubtopics)
      console.log('Mapped aptitude subtopics:', mappedAptitudeSubtopics)

      return {
        ...baseAssessment,
        aptitudeType: assessment.aptitudeType || null,
        aptitudeSubtopics: mappedAptitudeSubtopics,
        difficultySettings: assessment.difficultySettings || { easy: 0, medium: 0, hard: 0 },
        difficultyLevel: assessment.difficultyLevel || null,
        allowNegativeMarking: assessment.allowNegativeMarking || false,
      }
    }
    else if (assessment.assessmentType === 'Hinglish') {
      // Backward compat: treat existing Hinglish data as Communication
      return {
        ...baseAssessment,
        assessmentType: 'Communication',
        cefrLevel: assessment.cefrLevel || 'B1',
        assessmentDomain: assessment.assessmentDomain || 'Universal',
        responseLanguage: assessment.responseLanguage || 'Hindi',
        generatedQuestions: assessment.generatedQuestions || null,
        enabledSections: assessment.enabledSections || [],
      }
    }
    else if (assessment.assessmentType === 'AI_Interview') {
      return {
        ...baseAssessment,
        interviewConfig: assessment.interviewConfig || {}
      }
    }
    else {
      // For any other assessment type, return only base fields
      return baseAssessment
    }
  })
}


export const createCustomSectionQuestions =
  (entityId, entityName, sections) =>
    async dispatch => {
      dispatch(setLoading(true));

      try {
        console.log('📤 Creating custom section questions:', {
          entityId,
          entityName,
          sectionsCount: sections.length
        });

        // Check if any section has Excel file
        const hasExcelSection = sections.some(s => s.excel instanceof File);
        const hasManualSection = sections.some(s => s.questions && s.questions.length > 0);

        // ✅ If Excel section exists, use FormData
        if (hasExcelSection) {
          const formData = new FormData();

          formData.append('entity_id', entityId);
          formData.append('entity_name', entityName);

          sections.forEach((section, sectionIndex) => {
            formData.append(`sections[${sectionIndex}][section_name]`, section.section_name);

            if (section.excel && section.excel instanceof File) {
              console.log(`📎 Attaching Excel file for section ${sectionIndex}:`, section.excel.name);
              formData.append(`sections[${sectionIndex}][excel]`, section.excel);
            }
          });

          console.log('📦 Sending FormData with Excel file(s)');

          const response = await adminRequest.post(
            '/assessment/createSectionquestions?isFileUpload=true',  // ← Added query param
            formData,
            {
              headers: { 'Content-Type': 'multipart/form-data' }
            }
          );

          console.log('✅ Section questions created:', response.data);
          dispatch(setLoading(false));
          return response.data;
        }
        // ✅ If Manual section (no Excel), use JSON
        else if (hasManualSection) {
          const payload = {
            entity_id: entityId,
            entity_name: entityName,
            sections: sections.map(section => ({
              section_name: section.section_name,
              questions: (section.questions || []).map(q => ({
                question_text: q.question_text,
                question_image_key: q.question_image_key || null,
                options: q.options.map(opt => ({
                  option_text: opt.option_text,
                  option_image_key: opt.option_image_key || null
                })),
                correct_opt: q.correct_opt
              }))
            }))
          };

          console.log('📦 Sending JSON payload:', JSON.stringify(payload, null, 2));

          const response = await adminRequest.post(
            '/assessment/createSectionquestions?isFileUpload=false',  // ← Added query param
            payload
          );

          console.log('✅ Section questions created:', response.data);
          dispatch(setLoading(false));
          return response.data;
        }

        throw new Error('No valid sections to create');
      } catch (err) {
        console.error('❌ createCustomSectionQuestions failed:', err);
        dispatch(setLoading(false));
        throw err;
      }
    };


export const fetchCustomSections = (entityId) => async (dispatch) => {
  dispatch(setLoading(true));

  try {
    console.log('📥 Fetching custom sections for entity:', entityId);

    const response = await adminRequest.get(
      `/assessment/getCustomSections?entityId=${entityId}`
    );

    console.log('✅ Custom sections fetched:', response.data);

    dispatch(setLoading(false));

    return {
      success: true,
      sections: response.data || []
    };
  } catch (error) {
    console.error('❌ Failed to fetch custom sections:', error);
    dispatch(setLoading(false));

    return {
      success: false,
      error: error.response?.data?.message || error.message,
      sections: []
    };
  }
};


export const fetchCustomSectionQuestions = (sectionId) => async (dispatch) => {
  dispatch(setLoading(true));

  try {
    const response = await adminRequest.get(
      `/assessment/getQuestionsForCustomSection?section_id=${sectionId}`
    );
    dispatch(setLoading(false));
    return { success: true, questions: response.data || [] };
  } catch (error) {
    dispatch(setLoading(false));
    return {
      success: false,
      error: error.response?.data?.message || error.message,
      questions: []
    };
  }
};

export const editCustomAssessmentQuestion = (questionData) => async (dispatch) => {
  dispatch(setLoading(true));

  try {
    const response = await adminRequest.put(
      '/assessment/editCustomAssessmentQuestion',
      questionData
    );
    dispatch(setLoading(false));
    return { success: true, data: response.data };
  } catch (error) {
    dispatch(setLoading(false));
    return {
      success: false,
      error: error.response?.data?.message || error.message
    };
  }
};

export const deleteCustomAssessmentQuestion = (questionId) => async (dispatch) => {
  dispatch(setLoading(true));

  try {
    const response = await adminRequest.delete(
      '/assessment/deleteCustomAssessmentQuestion',
      { data: { question_id: questionId } }
    );
    dispatch(setLoading(false));
    return { success: true, data: response.data };
  } catch (error) {
    dispatch(setLoading(false));
    return {
      success: false,
      error: error.response?.data?.message || error.message
    };
  }
};
export const createAssessments = assessments => async dispatch => {
  dispatch(setLoading(true));

  console.log('createAssessments received:', JSON.parse(JSON.stringify(assessments)));

  try {
    let aptitudeTopicsData;
    try {
      aptitudeTopicsData = await dispatch(fetchAptitudeTopics())
    } catch (error) {
      console.warn('Failed to fetch aptitude topics, proceeding without dynamic mapping:', error)
    }

    const filteredData = filterAssessmentData(assessments, aptitudeTopicsData)
    console.log('Filtered assessment data:', filteredData)

    const responses = [];

    // Process each assessment
    for (const assessment of filteredData) {
      console.log('Processing assessment in createAssessments:', JSON.parse(JSON.stringify(assessment)));

      // Create the request body
      const requestBody = {
        name: assessment.name,
        instructions: assessment.instructions || '',
        allowProctoring: assessment.allowProctoring || false,
        allowVerification: assessment.allowVerification !== false,
        assessmentDomain: assessment.assessmentDomain || '',
        assessmentType: assessment.assessmentType,
        bulkUploadData: assessment.bulkUploadData || [],
        create: assessment.create || false,
        email: assessment.email,
        entityId: assessment.entityId,
        entityType: assessment.entityType,
        startDate: assessment.startDate,
        endDate: assessment.endDate,
        startTime: assessment.startTime,
        endTime: assessment.endTime,
      };

      // Copy all properties from the assessment to ensure nothing is lost
      Object.keys(assessment).forEach(key => {
        if (!['id', 'isSaved', 'isCheckboxSelected'].includes(key)) {
          requestBody[key] = assessment[key];
        }
      });
      if (assessment.assessmentType === 'Custom_Assessment') {
        // ✅ Use the sectionConfigurations already built by filterAssessmentData
        // It's already in the assessment object, just ensure it gets to requestBody
        requestBody.sectionConfigurations = assessment.sectionConfigurations || [];

        console.log('✅ Custom Assessment final sectionConfigurations:', requestBody.sectionConfigurations);
      }
      // For Role-Based assessments
      if (assessment.assessmentType === 'Role_Based') {
        console.log('Role-Based assessment full object:', JSON.parse(JSON.stringify(assessment)));

        requestBody.roleName = assessment.roleName;
        requestBody.skills = assessment.selectedSkills || assessment.skills || [];
        requestBody.seniority = assessment.seniority;
        requestBody.jobDescription = assessment.jobDescription || '';
        requestBody.industry_domain = assessment.industry_domain || '';
        requestBody.generatedQuestions = assessment.generatedQuestions;

        console.log('Role-based assessment details after setting:', {
          roleName: requestBody.roleName,
          skills: requestBody.skills,
          seniority: requestBody.seniority,
          jobDescription: requestBody.jobDescription,
          industry_domain: requestBody.industry_domain,
          hasGeneratedQuestions: !!requestBody.generatedQuestions
        });
      }

      console.log(`Sending ${assessment.entityType} assessment ${assessment.name}:`, JSON.parse(JSON.stringify(requestBody)));

      try {
        let endpoint = '/assessment/assignAssessment';

        if (assessment.assessmentType === 'Role_Based') {
          endpoint = '/assessment/assignRoleBasedAssessment';
        }

        console.log('[createAssessments] sending payload keys:', Object.keys(requestBody || {}));

        const response = await adminRequest.post(endpoint, requestBody);
        responses.push(response);
      } catch (err) {
        console.error(`Error creating assessment ${assessment.name}:`, err);
        throw err;
      }
    }

    dispatch(setLoading(false));
    return responses;
  } catch (err) {
    dispatch(setLoading(false));
    throw err;
  }
};


export const fetchSubscriptionStates = () => async dispatch => {
  try {
    const data = await elasticSearchRequest.get(
      `/search/states?currentPage=0&pageLimit=50&countryId=6364ed8ae0338a14ae729651`
    )
    dispatch(setSubscriptionStates(data?.data?.data?.result || []))

    return data?.data?.data?.result
  } catch (error) { }
}

export const fetchSubscriptionCities = state => async dispatch => {
  dispatch(setLoading(true))

  let county = `countryId=6364ed8ae0338a14ae729651`
  let stateId = state ? `&stateId=${state.id}` : ''
  let searchValue = ''
  let pageNum = ''
  let limit = ``
  try {
    const data = await elasticSearchRequest.get(
      `/search/cities?${limit}${county}${stateId}${searchValue}${pageNum}`
    )
    dispatch(setSubscriptionCities(data?.data?.data?.result || []))
    if (data?.data?.data?.result?.length === 0) {
      !searchValue && ErrorMessage('No cities available for selected state!')
    }
    return data?.data?.data?.result
  } catch (error) {
    dispatch(setError(error.message))
    throw error
  } finally {
    dispatch(setLoading(false))
  }
}

// export const fetchSubscriptionInstitutes = (city,state) => async dispatch => {
//   dispatch(setLoading(true))
//   const cityName = city.name
//   try {
//     const response = await adminRequest.get(
//       '/assessment/getAllInstitutesByCity',
//       {
//         params: { cityName },
//       }
//     )
//     dispatch(setSubscriptionInstitutes(response.data.data))
//     return response.data.data
//   } catch (error) {
//     dispatch(setError(error.message))
//     throw error
//   } finally {
//     dispatch(setLoading(false))
//   }
// }

export const fetchSubscriptionInstitutes = (city, state, notSubscription = false) => async dispatch => {
  dispatch(setLoading(true))

  const current = `&pageLimit=1000`
  const stateName = `&state=${state.name}`
  const cityName = `&city=${city.name}`
  const notSubscriptionData = notSubscription ? `&notSubscription=${true}` : ``

  try {
    const data = await elasticSearchRequest.get(
      `/institutes?${current}${stateName}${cityName}&isActive=true${notSubscriptionData}`
    )
    dispatch(setSubscriptionInstitutes(data?.data?.data.result || []))
    dispatch(setLoading(false))
  } catch (error) {
    dispatch(setError(error.message))
    throw error
  } finally {
    dispatch(setLoading(false))
  }
}

export const fetchCorporateCompanies = (city, state, notSubscription = false) => async dispatch => {
  dispatch(setLoading(true))

  const current = `&pageLimit=1000`
  const stateName = state ? `&state=${state.name}` : ``
  const cityName = city ? `&city=${city.name}` : ``
  const notSubscriptionData = notSubscription ? `&notSubscription=${true}` : ``

  try {
    const data = await elasticSearchRequest.get(
      `/corporates/list?${current}${stateName}${cityName}${notSubscriptionData}`
    )
    dispatch(setCorporateCompanies(data?.data?.data.list || []))

    return data?.data?.data
  } catch (error) {
    dispatch(setError(error.message))
    throw error
  } finally {
    dispatch(setLoading(false))
  }
}

// Reads the corporate's or institute's feature-access flags so the Feature Access toggles can
// render their real saved state. Resolves to {} on failure rather than
// rejecting: a flag we cannot read renders as off, which matches the backend's
// fail-closed behaviour, and must not block the rest of the screen loading.
export const getFeatureAccess = (entityId, entityType = 'corporate') => async () => {
  try {
    const response = await adminRequest.get('/assessment/featureAccess', {
      params: { entityId, entityType },
    })
    return response?.data?.data || {}
  } catch (error) {
    console.error('Error fetching feature access:', error)
    return null
  }
}

export const assignSubscription =
  (entityId, assessmentTypes, entityType = 'college', accessLevel, practiceDegreeSets = [], editId = null, roleBasedTokenLimit, tokenLimits, whatsappNotificationEnabled, unlimitedTypes = [], contractDates = {}, assessmentCreationEnabled, assessmentManagementEnabled, removedTypes = []) =>
    async dispatch => {
      console.log('assignSubscription', entityId, assessmentTypes, entityType, practiceDegreeSets, 'roleBasedTokenLimit:', roleBasedTokenLimit, 'tokenLimits:', tokenLimits, 'unlimitedTypes:', unlimitedTypes)
      dispatch(assignSubscriptionRequest())
      try {
        const response = await adminRequest.post(
          '/assessment/assignSubscription',
          {
            entityId,
            assessmentTypes,
            entityType,
            accessLevel,
            practiceDegreeSets,
            roleBasedTokenLimit,
            // Per-type limits for non-role-based types; omitted keys => unlimited.
            ...(tokenLimits && Object.keys(tokenLimits).length ? { tokenLimits } : {}),
            // Types with no credit cap. Sent only when non-empty so an older
            // caller's payload is byte-identical to before.
            ...(unlimitedTypes?.length ? { unlimitedTypes } : {}),
            // Types the admin unticked from the saved subscription; the API
            // deletes only these. Omitted when nothing was unticked.
            ...(removedTypes?.length ? { removedTypes } : {}),
            // Contract window. Omitted entirely when the picker was left
            // untouched, which tells the API to keep the saved window.
            ...contractDates,
            ...(entityType === 'corporate' && typeof assessmentManagementEnabled === 'boolean'
              ? { assessmentManagementEnabled }
              : {}),
            ...(typeof assessmentCreationEnabled === 'boolean'
              ? { assessmentCreationEnabled }
              : {}),
            // Corporate-only feature flag. Sent only when it is a real boolean —
            // omitting it tells the API to leave the current setting alone.
            ...(typeof whatsappNotificationEnabled === 'boolean'
              ? { whatsappNotificationEnabled }
              : {}),
          }
        )

        dispatch(
          assignSubscriptionSuccess(
            response.data.message || 'Subscription assigned successfully'
          )
        )

        function formatDate(date) {
          let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

          if (month.length < 2)
            month = '0' + month;
          if (day.length < 2)
            day = '0' + day;

          return [year, month, day].join('-');
        }


        let payloadData = {
          "query_date": "1990-01-01"// This will format today's date as "yyyy-mm-dd"
        };
        if (entityType === "college")
          await elasticSearchSyncRequest.post(`/sync/institutes_master`, payloadData)
        if (entityType === "corporate")
          await elasticSearchSyncRequest.post(`/sync/corporate_list`, payloadData)

        return response.data
      } catch (error) {
        dispatch(
          assignSubscriptionFailure(
            error.message || 'Failed to assign subscription'
          )
        )
        throw error
      }
    }

export const scheduleAssessments = (schedulePayloads) => async (dispatch) => {
  dispatch(scheduleAssessmentsRequest());
  try {
    // The API call is made for each schedule payload.
    // Promise.all ensures all requests are sent.
    schedulePayloads.forEach((payload, idx) => {
      console.log(`Frontend: Sending schedule payload #${idx + 1}:`, payload);
    });

    const promises = schedulePayloads.map(payload =>
      adminRequest.post('/assessment/schedule', payload)
    );

    const responses = await Promise.all(promises);

    // Assuming all responses are successful if Promise.all resolves
    const successMessage = responses[0]?.data?.message || 'Assessments scheduled successfully';
    dispatch(scheduleAssessmentsSuccess(successMessage));

    // Return the data from the first response for the success dialog
    return responses[0]?.data;

  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to schedule assessments';
    dispatch(scheduleAssessmentsFailure(errorMessage));
    throw error; // Re-throw the error to be caught in the component
  }
};
export const fetchProctoringDetails =
  assessmentAssignedId => async dispatch => {
    dispatch(setLoading(true))
    try {
      if (!assessmentAssignedId) {
        throw new Error('Assessment assigned ID is required')
      }

      const response = await adminRequest.get(
        '/assessment/getProctoringDetails',
        {
          params: { assessmentAssignedId },
        }
      )
      return response.data.data
    } catch (error) {
      dispatch(setError(error.message))
      throw error
    } finally {
      dispatch(setLoading(false))
    }
  }

export const fetchFeatureInstitutes = (page, search, orderBy, sortBy) => async dispatch => {
  try {
    const response = await elasticSearchRequest.get(
      `institutes?pageNo=${page}&pageLimit=10&subscription=true&search=${search}&orderBy=${orderBy}&sort=${sortBy}`
    )
    console.log(response?.data?.data, 'response?.data?.data')
    return response?.data?.data
  } catch (error) {
    throw error
  } finally {
  }
}

export const fetchFeatureCorporate = (page, search, orderBy, sortBy) => async dispatch => {
  try {
    const response = await elasticSearchRequest.get(
      `/corporates/list?currentPage=${page}&pageLimit=10&subscription=true&search=${search}&orderBy=${orderBy}&sort=${sortBy}`
    )
    console.log(response?.data?.data, 'response?.data?.data')
    return response?.data?.data
  } catch (error) {
    throw error
  } finally {
  }
}
// Media actions types
export const FETCH_MEDIA_KEYS_REQUEST = 'FETCH_MEDIA_KEYS_REQUEST'
export const FETCH_MEDIA_KEYS_SUCCESS = 'FETCH_MEDIA_KEYS_SUCCESS'
export const FETCH_MEDIA_KEYS_FAILURE = 'FETCH_MEDIA_KEYS_FAILURE'
export const FETCH_MEDIA_URLS_REQUEST = 'FETCH_MEDIA_URLS_REQUEST'
export const FETCH_MEDIA_URLS_SUCCESS = 'FETCH_MEDIA_URLS_SUCCESS'
export const FETCH_MEDIA_URLS_FAILURE = 'FETCH_MEDIA_URLS_FAILURE'
export const RESET_MEDIA_STATE = 'RESET_MEDIA_STATE'

// Media action creators
export const fetchMediaKeysRequest = () => ({
  type: FETCH_MEDIA_KEYS_REQUEST,
})

export const fetchMediaKeysSuccess = mediaFiles => ({
  type: FETCH_MEDIA_KEYS_SUCCESS,
  payload: mediaFiles,
})

export const fetchMediaKeysFailure = error => ({
  type: FETCH_MEDIA_KEYS_FAILURE,
  payload: error,
})

export const fetchMediaUrlsRequest = () => ({
  type: FETCH_MEDIA_URLS_REQUEST,
})

export const fetchMediaUrlsSuccess = mediaUrls => ({
  type: FETCH_MEDIA_URLS_SUCCESS,
  payload: mediaUrls,
})

export const fetchMediaUrlsFailure = error => ({
  type: FETCH_MEDIA_URLS_FAILURE,
  payload: error,
})

export const resetMediaState = () => ({
  type: RESET_MEDIA_STATE,
})

// Thunk to fetch media keys
export const fetchMediaKeys = assessmentAssignedId => async dispatch => {
  dispatch(fetchMediaKeysRequest())
  try {
    if (!assessmentAssignedId) {
      throw new Error('Assessment assigned ID is required')
    }

    // Make an API call to get the media keys
    const response = await adminRequest.get(
      '/assessment/getAudioVideoProctoring',
      {
        params: { assessmentAssignedId },
      }
    )

    //console.log('Media keys API response:', response.data)

    // Check if we have valid data
    if (!response.data?.data?.rows || !Array.isArray(response.data.data.rows)) {
      throw new Error('Invalid response format: missing data.rows array')
    }

    // Process the response data to create an array of file objects with types
    const rows = response.data.data.rows

    // Patterns to identify audio and video files
    const audioPatterns = ['audio', 'paragraph_reading', 'paragraph', 'reading', 'ai_interview_answer']
    const videoPatterns = ['video', 'video_respose', 'webcam']

    // Transform the raw rows into properly formatted media files array.
    // Preserve order so multi-video question sequence is retained.
    const mediaFiles = rows
      .map(row => {
        const fileName = (row.object_key || '').toLowerCase()

        // Determine if this is an audio or video file based on the filename
        let type = 'unknown'
        if (
          audioPatterns.some(pattern =>
            fileName.includes(pattern.toLowerCase())
          )
        ) {
          type = 'audio'
        } else if (
          videoPatterns.some(pattern =>
            fileName.includes(pattern.toLowerCase())
          )
        ) {
          type = 'video'
        }

        return {
          filename: row.object_key,
          type: type,
          questionId: row.question_id || null,
        }
      })
      .filter(file => file.type !== 'unknown') // Remove files we couldn't identify

    //console.log('Processed media files:', mediaFiles)

    dispatch(fetchMediaKeysSuccess(mediaFiles))
    return mediaFiles
  } catch (error) {
    console.error('Error fetching media keys:', error)
    dispatch(
      fetchMediaKeysFailure(error.message || 'Failed to fetch media keys')
    )
    throw error
  }
}

// Thunk to fetch media URLs
export const fetchMediaUrls = mediaFiles => async dispatch => {
  dispatch(fetchMediaUrlsRequest())
  try {
    if (!mediaFiles || !Array.isArray(mediaFiles) || mediaFiles.length === 0) {
      throw new Error('Media files array is required')
    }

    //console.log('Fetching media URLs for files:', mediaFiles)

    // Get the auth token
    const token = localStorage.getItem('token')
    const API_URL = process.env.STD_API_URL
    const baseUrl = API_URL.endsWith('/') ? API_URL : `${API_URL}/`

    // Make an API call to the student API to get signed URLs for the media files
    const response = await fetch(
      `${baseUrl}students/assessments/getMediaUrls`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // Raw token — backend verifyToken does not strip Bearer.
          Authorization: token,
        },
        body: JSON.stringify({ files: mediaFiles }),
      }
    )

    if (!response.ok) {
      const errorText = await response.text()
      throw new Error(`Failed to fetch media URLs: ${errorText}`)
    }

    const urlData = await response.json()
    //console.log('URL response:', urlData)

    if (!urlData.data?.urls) {
      throw new Error('Invalid response format: missing data.urls')
    }

    const urls = urlData.data.urls
    // Media the backend refused to sign because it is past its retention
    // window. Tracked separately from a genuine failure so the player can say
    // "expired by policy" rather than sending someone to check CORS.
    const expiredFiles = Array.isArray(urlData.data.expired) ? urlData.data.expired : []

    // Build full lists for both types so multi-video / multi-audio answers
    // (e.g. role-based assessments with multiple video questions) are all available.
    const audioItems = mediaFiles
      .filter(f => f.type === 'audio')
      .map(f => ({
        filename: f.filename,
        questionId: f.questionId || null,
        url: urls[f.filename] || null,
        chapters: f.chapters || null,
      }))
      .filter(item => item.url)

    const videoItems = mediaFiles
      .filter(f => f.type === 'video')
      .map(f => ({
        filename: f.filename,
        questionId: f.questionId || null,
        url: urls[f.filename] || null,
      }))
      .filter(item => item.url)

    // Preserve backward-compat single-URL fields used by older modal call sites.
    const audioUrl = audioItems[0]?.url || null
    const videoUrl = videoItems[0]?.url || null

    const mediaUrls = {
      audio: audioUrl,
      video: videoUrl,
      audios: audioItems,
      videos: videoItems,
      expiredCount: expiredFiles.length,
    }

    //console.log('Processed media URLs:', mediaUrls)
    dispatch(fetchMediaUrlsSuccess(mediaUrls))
    return mediaUrls
  } catch (error) {
    console.error('Error fetching media URLs:', error)
    dispatch(
      fetchMediaUrlsFailure(error.message || 'Failed to fetch media URLs')
    )
    throw error
  }
}

// PDF Report action types
export const CHECK_REPORT_AVAILABILITY_REQUEST =
  'CHECK_REPORT_AVAILABILITY_REQUEST'
export const CHECK_REPORT_AVAILABILITY_SUCCESS =
  'CHECK_REPORT_AVAILABILITY_SUCCESS'
export const CHECK_REPORT_AVAILABILITY_FAILURE =
  'CHECK_REPORT_AVAILABILITY_FAILURE'

// PDF Report action creators
export const checkReportAvailabilityRequest = () => ({
  type: CHECK_REPORT_AVAILABILITY_REQUEST,
})

export const checkReportAvailabilitySuccess = available => ({
  type: CHECK_REPORT_AVAILABILITY_SUCCESS,
  payload: available,
})

export const checkReportAvailabilityFailure = error => ({
  type: CHECK_REPORT_AVAILABILITY_FAILURE,
  payload: error,
})
export const generateRoleBasedQuestionsRequest = () => ({
  type: GENERATE_ROLE_BASED_QUESTIONS_REQUEST,
});
export const generateRoleBasedQuestionsSuccess = (questions) => ({
  type: GENERATE_ROLE_BASED_QUESTIONS_SUCCESS,
  payload: questions,
});
export const generateRoleBasedQuestionsFailure = (error) => ({
  type: GENERATE_ROLE_BASED_QUESTIONS_FAILURE,
  payload: error,
});

export const generateRoleBasedQuestions = (payload) => async (dispatch) => {
  dispatch(generateRoleBasedQuestionsRequest());
  try {
    // Replace with your actual API endpoint
    const response = await adminRequest.post('/assessment/generateRoleBasedQuestions', payload);
    dispatch(generateRoleBasedQuestionsSuccess(response.data.data));
    return response.data.data;
    console.log('API response for role-based questions:', response.data);
  } catch (error) {
    dispatch(generateRoleBasedQuestionsFailure(error.message || 'Failed to generate questions'));
    throw error;
  }
};



export const generateTopicBasedQuestionsRequest = () => ({
  type: GENERATE_HINGLISH_QUESTIONS_REQUEST,
});
export const generateTopicBasedQuestionsSuccess = (questions) => ({
  type: GENERATE_HINGLISH_QUESTIONS_SUCCESS,
  payload: questions,
});
export const generateTopicBasedQuestionsFailure = (error) => ({
  type: GENERATE_HINGLISH_QUESTIONS_FAILURE,
  payload: error,
});

export const generateTopicBasedQuestions = (payload) => async (dispatch) => {
  dispatch(generateTopicBasedQuestionsRequest());
  try {
    const response = await adminRequest.post('/assessment/generateTopicBasedQuestions', payload);
    dispatch(generateTopicBasedQuestionsSuccess(response.data.data));
    return response.data.data;
  } catch (error) {
    dispatch(generateTopicBasedQuestionsFailure(error.message || 'Failed to generate topic-based questions'));
    throw error;
  }
};

// Backward compatibility aliases
export const generateHinglishQuestionsRequest = generateTopicBasedQuestionsRequest;
export const generateHinglishQuestionsSuccess = generateTopicBasedQuestionsSuccess;
export const generateHinglishQuestionsFailure = generateTopicBasedQuestionsFailure;
export const generateHinglishQuestions = generateTopicBasedQuestions;

export const assignRoleBasedAssessmentRequest = () => ({
  type: ASSIGN_ROLE_BASED_ASSESSMENT_REQUEST,
});

export const assignRoleBasedAssessmentSuccess = (data) => ({
  type: ASSIGN_ROLE_BASED_ASSESSMENT_SUCCESS,
  payload: data,
});

export const assignRoleBasedAssessmentFailure = (error) => ({
  type: ASSIGN_ROLE_BASED_ASSESSMENT_FAILURE,
  payload: error,
});

// Add this thunk action with the other thunk actions
export const assignRoleBasedAssessment = (payload) => async (dispatch) => {
  dispatch(assignRoleBasedAssessmentRequest());
  try {
    const response = await adminRequest.post('/assessment/assignRoleBasedAssessment', payload);
    dispatch(assignRoleBasedAssessmentSuccess(response.data));
    return response.data;
  } catch (error) {
    dispatch(assignRoleBasedAssessmentFailure(error.message || 'Failed to assign role-based assessment'));
    throw error;
  }
};

export const assignAIInterview = (data) => async (dispatch) => {
  try {
    dispatch({ type: ASSIGN_AI_INTERVIEW_REQUEST })
    const response = await adminRequest.post('/assessment/assignAssessment', {
      ...data,
      assessmentType: 'AI_Interview',
    })
    dispatch({
      type: ASSIGN_AI_INTERVIEW_SUCCESS,
      payload: response.data
    })
    return response.data
  } catch (error) {
    dispatch({
      type: ASSIGN_AI_INTERVIEW_FAILURE,
      payload: error.response?.data?.message || error.message
    })
    throw error
  }
}

// Thunk to check if PDF report is available by using the generatePDFReport endpoint
export const checkReportAvailability =
  (assessmentAssignedId, studentId) => async dispatch => {
    dispatch(checkReportAvailabilityRequest())
    try {
      if (!assessmentAssignedId || !studentId) {
        console.warn(
          'Missing required parameters for checking report availability'
        )
        dispatch(checkReportAvailabilitySuccess(false))
        return false
      }

      try {
        const response = await studentRequest.get(
          `students/assessments/checkReportAvailability?assessmentAssignedId=${assessmentAssignedId}&studentId=${studentId}`
        )

        const isAvailable = response?.data?.data?.available || false
        dispatch(checkReportAvailabilitySuccess(isAvailable))
        return isAvailable
      } catch (fetchError) {
        dispatch(checkReportAvailabilitySuccess(false))
        return false
      }
    } catch (error) {
      console.error('Error in checkReportAvailability action:', error)
      dispatch(
        checkReportAvailabilityFailure(
          error.message || 'Failed to check report availability'
        )
      )
      return false
    }
  }

// Recalculation Action Types
export const RECALCULATE_ASSESSMENT_REQUEST = 'RECALCULATE_ASSESSMENT_REQUEST'
export const RECALCULATE_ASSESSMENT_SUCCESS = 'RECALCULATE_ASSESSMENT_SUCCESS'
export const RECALCULATE_ASSESSMENT_FAILURE = 'RECALCULATE_ASSESSMENT_FAILURE'

// Recalculation Action Creators
export const recalculateAssessmentRequest = () => ({
  type: RECALCULATE_ASSESSMENT_REQUEST,
})

export const recalculateAssessmentSuccess = (data) => ({
  type: RECALCULATE_ASSESSMENT_SUCCESS,
  payload: data,
})

export const recalculateAssessmentFailure = (error) => ({
  type: RECALCULATE_ASSESSMENT_FAILURE,
  payload: error,
})

// Fetch CEFR Pie Chart Data
export const fetchCefrChartData = (assessmentId, passingYear = '', isDiagnosis = false) => async dispatch => {
  console.log('Fetching CEFR Chart Data:', { assessmentId, passingYear, isDiagnosis })
  try {
    const params = new URLSearchParams({
      assessmentInstituteMapId: assessmentId,
      ...(passingYear ? { passingYear } : {}),
      is_diagnosis: isDiagnosis
    });

    console.log('Making request to:', `/assessment/getPiChartDataForCefr?${params.toString()}`);

    const response = await studentRequest.get(
      `/assessment/getPiChartDataForCefr?${params.toString()}`
    );

    console.log('CEFR API Response Status:', response.status);
    console.log('CEFR API Response Data:', response.data);

    if (response.data && typeof response.data === 'object') {
      if (response.data.message === 'Success' || response.data.message === 'success') {
        console.log('CEFR API Success - Data:', response.data.data);
        return response.data.data;
      } else if (response.data.message) {
        console.warn('CEFR API Warning:', response.data.message);
        if (response.data.message.includes('No CEFR data found')) {
          console.warn('No CEFR data available for this assessment - returning empty dataset');
          return {
            A1: { count: 0, percentage: 0 },
            A2: { count: 0, percentage: 0 },
            B1: { count: 0, percentage: 0 },
            B2: { count: 0, percentage: 0 },
            C1: { count: 0, percentage: 0 },
            C2: { count: 0, percentage: 0 },
            totalStudentCount: 0
          };
        }
        throw new Error(response.data.message);
      } else if (response.data.error) {
        console.error('CEFR API Error:', response.data.error);
        throw new Error(response.data.error);
      }
    }

    console.error('Unexpected response format from CEFR API');
    throw new Error('Unexpected response format from server');

  } catch (error) {
    console.error('CEFR API Error:', error);

    if (error.response) {
      console.error('Error Response Status:', error.response.status);
      console.error('Error Response Headers:', error.response.headers);
      console.error('Error Response Data:', error.response.data);

      if (error.response.status === 401) {
        console.warn('Authentication error - clearing tokens');
        localStorage.removeItem('token');
        sessionStorage.removeItem('token');
        window.location.href = '/login';
      }
    } else if (error.request) {
      console.error('No response received:', error.request);
    } else {
      console.error('Error setting up request:', error.message);
    }

    throw error;
  }
}

// Fetch Consistency Data
export const fetchConsistencyData = (assessmentId, assessmentType = 'communication', instituteId = '', passingYear = '', isDiagnosis = false) => async (dispatch) => {
  try {
    console.log('=== Consistency API Call ===');
    console.log('Assessment-specific ID for Consistency:', assessmentId);
    console.log('Assessment Type:', assessmentType);
    console.log('Institute ID:', instituteId);
    console.log('Passing Year:', passingYear);
    console.log('Is Diagnosis:', isDiagnosis);

    if (!assessmentId) {
      throw new Error('Assessment ID is required');
    }

    if (!instituteId) {
      throw new Error('Institute ID is required');
    }

    if (!['communication', 'aptitude'].includes(assessmentType.toLowerCase())) {
      console.warn(`Invalid assessment type: ${assessmentType}. Defaulting to 'communication'`);
      assessmentType = 'communication';
    }

    const params = new URLSearchParams({
      assessmentInstituteMapID: assessmentId,
      assessmentType: assessmentType.toLowerCase(),
      instituteId,
      ...(passingYear ? { passingYear } : {}),
      is_diagnosis: isDiagnosis
    });

    const url = `/assessment/getConsistencyData?${params.toString()}`;
    console.log('API URL:', url);

    const response = await studentRequest.get(url);

    console.log('=== Consistency API Response ===');
    console.log('Status:', response.status);
    console.log('Data type:', typeof response.data);
    console.log('Data:', response.data);

    if (response.data && response.data.message?.toLowerCase() === 'success') {
      console.log('Consistency API Success - Data:', response.data.data);
      return response.data.data;
    } else if (response.data && response.data.message) {
      const errorMsg = response.data.message || 'Unknown error from server';
      console.warn('Consistency API Warning:', errorMsg);
      throw new Error(`API Error: ${errorMsg}`);
    } else {
      console.error('Unexpected response format:', response.data);
      throw new Error('Unexpected response format from server');
    }

  } catch (error) {
    console.error('Consistency API Error:', {
      message: error.message,
      status: error.response?.status,
      url: error.config?.url,
      method: error.config?.method,
      response: error.response?.data
    });

    let errorMessage = 'Failed to load consistency data';

    if (error.code === 'ECONNABORTED') {
      errorMessage = 'Request timed out. Please check your connection and try again.';
    } else if (!navigator.onLine) {
      errorMessage = 'Network connection lost. Please check your internet connection.';
    } else if (error.response) {
      if (error.response.status === 500) {
        errorMessage = 'Server error. Please try again later.';
      } else if (error.response.data?.message) {
        errorMessage = error.response.data.message;
      }
    }

    const enhancedError = new Error(errorMessage);
    enhancedError.originalError = error;
    enhancedError.status = error.response?.status;

    dispatch({
      type: 'API_ERROR',
      payload: {
        action: 'fetchConsistencyData',
        error: enhancedError.message,
        timestamp: new Date().toISOString()
      }
    });

    throw enhancedError;
  }
}

// Fetch Aptitude Assessment Groups (for line chart)
export const fetchAptitudeAssessmentGroups = (assessmentId, passingYear, scheduleId = null) => async (dispatch) => {
  try {
    console.log('=== Aptitude Assessment Groups API Call ===');
    console.log('Assessment ID:', assessmentId);
    console.log('Passing Year:', passingYear);

    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    console.log('Using token:', token ? 'Token exists' : 'No token found');

    const url = `/assessment/getAptitudeAssessmentGroups?assessmentInstituteMapID=${assessmentId}${passingYear ? `&passingYear=${passingYear}` : ''}`;
    console.log('Making request to:', url);

    const response = await adminRequest.get(
      url,
      {
        validateStatus: function (status) {
          return status >= 200 && status < 500;
        }
      }
    );

    if (response.status === 200 && response.data && response.data.message === 'Success') {
      console.log('Successfully fetched aptitude assessment groups:', response.data.data);
      return response.data.data;
    } else {
      console.error('Failed to fetch aptitude assessment groups:', response.data);
      throw new Error(response.data?.message || 'Failed to fetch aptitude assessment groups');
    }
  } catch (error) {
    console.error('Error in fetchAptitudeAssessmentGroups:', error);
    throw error;
  }
};

// Fetch Communication Assessment Groups with Normalized Scores (for line chart)
export const fetchCommunicationAssessmentGroups = (assessmentId, passingYear, scheduleId = null) => async (dispatch) => {
  try {
    console.log('=== Fetching Communication Assessment Groups ===');
    console.log('Assessment ID:', assessmentId);
    console.log('Passing Year:', passingYear);

    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    console.log('Using token:', token ? 'Token exists' : 'No token found');

    const url = `/assessment/getCommunicationAssessmentGroupsWithNormalizedScores?assessmentInstituteMapID=${assessmentId}${passingYear ? `&passingYear=${passingYear}` : ''}`;
    console.log('Making request to:', url);

    const response = await adminRequest.get(
      url,
      {
        validateStatus: function (status) {
          return status >= 200 && status < 500;
        }
      }
    );

    if (response.status === 200 && response.data && response.data.message === 'Success') {
      console.log('Successfully fetched communication assessment groups:', response.data.data);
      return response.data.data;
    }
    console.warn('[fetchCommunicationAssessmentGroups] Non-success response:', {
      status: response.status,
      data: response.data,
    });
    return [];
  } catch (error) {
    console.error('Error in fetchCommunicationAssessmentGroups, returning []:', error);
    return [];
  }
};

// Fetch Aptitude Pie Chart Data
export const fetchAptitudePieChartData = (assessmentId, passingYear = '', isDiagnosis = false) => async dispatch => {
  console.log('Fetching Aptitude Pie Chart Data:', { assessmentId, passingYear, isDiagnosis })
  try {
    const params = new URLSearchParams({
      assessmentInstituteMapId: assessmentId,
      ...(passingYear ? { passingYear } : {}),
      is_diagnosis: isDiagnosis
    });

    const apiPath = `/assessment/getPiChartDataForAptitude?${params.toString()}`
    console.log('Making request to:', apiPath);

    const response = await studentRequest.get(
      apiPath
    );

    if (response.status === 200 && response.data && (response.data.message === 'Success' || response.data.message === 'success')) {
      console.log('[Aptitude Pie] Endpoint success');
      return response.data.data;
    }

    console.error('[Aptitude Pie] Endpoint failed:', {
      status: response.status,
      data: response.data,
    })
    throw new Error(response.data?.message || 'Failed to fetch aptitude pie chart data')
  } catch (error) {
    console.error('Error in fetchAptitudePieChartData:', error);
    throw error;
  }
};

// Combined chart data fetcher using Promise.all
export const fetchAssessmentChartsData = (assessmentInstituteMapID, assessmentType = 'communication', instituteId = '', passingYear = '', isDiagnosis = false, scheduleId = null, attemptNumber = null) => async dispatch => {
  if (!assessmentInstituteMapID) {
    const errorMsg = 'Assessment Institute Map ID is required';
    console.error(errorMsg);
    dispatch({
      type: FETCH_ASSESSMENT_CHARTS_FAILURE,
      error: errorMsg,
      timestamp: new Date().toISOString()
    });
    throw new Error(errorMsg);
  }

  if (!['communication', 'aptitude', 'hinglish'].includes(assessmentType.toLowerCase())) {
    console.warn(`Invalid assessment type: ${assessmentType}. Defaulting to 'communication'`);
    assessmentType = 'communication';
  }

  console.log('=== [fetchAssessmentChartsData] Starting data fetch ===');
  console.log('- Assessment ID:', assessmentInstituteMapID);
  console.log('- Assessment Type:', assessmentType);
  console.log('- Institute ID:', instituteId);
  console.log('- Passing Year:', passingYear);
  console.log('- Is Diagnosis:', isDiagnosis);

  dispatch({
    type: FETCH_ASSESSMENT_CHARTS_REQUEST,
    meta: { assessmentId: assessmentInstituteMapID, assessmentType, isDiagnosis }
  });

  try {
    console.log('=== [fetchAssessmentChartsData] Fetching all chart data in parallel');

    try {
      console.log('Testing backend connectivity...')
      const health = await authRequest.get('/health')
      console.log('Backend connectivity test:', health.status)
    } catch (connectError) {
      console.error('Backend connectivity test failed:', connectError?.message || connectError)
      try {
        const base = (authRequest?.defaults?.baseURL || '').toString()
        console.error(`Expected API base from env: ${base} (authRequest)`)
      } catch (_) {
        // no-op
      }
    }

    const startTime = Date.now();

    const isCommunicationLike = ['communication', 'hinglish'].includes(assessmentType.toLowerCase());

    const [pieChartData, consistencyData, lineChartData] = await Promise.all([
      isCommunicationLike
        ? dispatch(fetchCefrChartData(assessmentInstituteMapID, passingYear, isDiagnosis))
          .catch(error => {
            console.error('Error in fetchCefrChartData:', error);
            return { labels: [], datasets: [{ data: [], backgroundColor: [] }] }
          })
        : dispatch(fetchAptitudePieChartData(assessmentInstituteMapID, passingYear, isDiagnosis))
          .catch(error => {
            console.error('Error in fetchAptitudePieChartData:', error);
            return { labels: [], datasets: [{ data: [], backgroundColor: [] }] }
          }),

      instituteId
        ? dispatch(fetchConsistencyData(assessmentInstituteMapID, assessmentType, instituteId, passingYear, isDiagnosis))
          .catch(error => {
            console.error('Error in fetchConsistencyData:', error);
            return { highConsistency: { count: 0, percentage: 0 }, moderateConsistency: { count: 0, percentage: 0 }, inconsistency: { count: 0, percentage: 0 }, totalStudentCount: 0 };
          })
        : Promise.resolve({ highConsistency: { count: 0, percentage: 0 }, moderateConsistency: { count: 0, percentage: 0 }, inconsistency: { count: 0, percentage: 0 }, totalStudentCount: 0 }),

      isDiagnosis
        ? Promise.resolve([])
        : assessmentType.toLowerCase() === 'aptitude'
          ? dispatch(fetchAptitudeAssessmentGroups(assessmentInstituteMapID, passingYear, scheduleId))
            .catch(error => {
              console.error('Error in fetchAptitudeAssessmentGroups:', error);
              throw new Error(`Aptitude Groups Error: ${error.message}`);
            })
          : dispatch(fetchCommunicationAssessmentGroups(assessmentInstituteMapID, passingYear, scheduleId))
            .catch(error => {
              console.error('Error in fetchCommunicationAssessmentGroups:', error);
              throw new Error(`Communication Groups Error: ${error.message}`);
            })
    ]);

    const endTime = Date.now();
    console.log(`=== [fetchAssessmentChartsData] All chart data fetched successfully in ${endTime - startTime}ms`);
    console.log('- Pie Chart Data:', pieChartData ? 'Received' : 'Missing');
    console.log('- Consistency Data:', consistencyData ? 'Received' : 'Missing');
    console.log('- Line Chart Data:',
      lineChartData ? `Received (${Array.isArray(lineChartData) ? lineChartData.length : 'object'} items)` : 'Missing');

    const chartData = {
      cefrData: isCommunicationLike ? pieChartData : null,
      aptitudePieData: assessmentType.toLowerCase() === 'aptitude' ? pieChartData : null,
      consistencyData,
      communicationGroupsData: isCommunicationLike ? lineChartData : [],
      aptitudeGroupsData: assessmentType.toLowerCase() === 'aptitude' ? lineChartData : [],
      assessmentType: assessmentType.toLowerCase(),
      assessmentId: assessmentInstituteMapID,
      lastUpdated: new Date().toISOString()
    };

    dispatch({
      type: FETCH_ASSESSMENT_CHARTS_SUCCESS,
      payload: chartData,
      meta: { assessmentId: assessmentInstituteMapID, assessmentType }
    });

    console.log('=== [fetchAssessmentChartsData] Successfully dispatched chart data to Redux store');

    return chartData;

  } catch (error) {
    console.error('=== [fetchAssessmentChartsData] Error fetching assessment charts data ===');
    console.error('Error Details:', {
      message: error.message,
      stack: error.stack,
      assessmentId: assessmentInstituteMapID,
      assessmentType,
      response: error.response ? {
        status: error.response.status,
        statusText: error.response.statusText,
        data: error.response.data
      } : 'No response',
      request: error.request ? 'Request made but no response received' : 'No request was made'
    });

    let errorMessage = error.message || 'An unknown error occurred while fetching chart data';

    if (error.code === 'ECONNABORTED') {
      errorMessage = 'Request timed out. Please check your connection and try again.';
    } else if (!navigator.onLine) {
      errorMessage = 'Network connection lost. Please check your internet connection.';
    } else if (error.response) {
      if (error.response.status === 500) {
        errorMessage = 'Server error. Please try again later.';
      } else if (error.response.data?.message) {
        errorMessage = error.response.data.message;
      }
    }

    const enhancedError = new Error(errorMessage);
    enhancedError.originalError = error;
    enhancedError.status = error.response?.status;

    dispatch({
      type: FETCH_ASSESSMENT_CHARTS_FAILURE,
      error: enhancedError.message,
      timestamp: new Date().toISOString(),
      meta: {
        assessmentId: assessmentInstituteMapID,
        assessmentType,
        error: enhancedError
      }
    });

    console.error('=== [fetchAssessmentChartsData] Error dispatched to Redux store');

    throw enhancedError;
  }
}

/**
 * Recalculate assessment scores for a student
 * @param {string} assessmentAssignedId - The assessment assigned ID
 * @returns {Promise<object>} - Result of the recalculation
 */
export const recalculateAssessment = (assessmentAssignedId) => async (dispatch) => {
  dispatch(recalculateAssessmentRequest())

  try {
    if (!assessmentAssignedId) {
      throw new Error('Assessment assigned ID is required')
    }

    const API_URL = process.env.STD_API_URL
    const baseUrl = API_URL.endsWith('/') ? API_URL : `${API_URL}/`

    const response = await fetch(
      `${baseUrl}assessment/resetForRecalculation?assessment_assigned_id=${assessmentAssignedId}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )

    const data = await response.json()

    if (!response.ok) {
      throw new Error(data.message || 'Failed to recalculate assessment')
    }

    dispatch(recalculateAssessmentSuccess(data))
    return { success: true, data }
  } catch (error) {
    console.error('Error recalculating assessment:', error)
    dispatch(recalculateAssessmentFailure(error.message || 'Failed to recalculate assessment'))
    return { success: false, error: error.message }
  }
}

// ============================================================
// Assessment States, TPO Student List, Charts, and Filter actions
// (ported from institute-react for Assessment UI replication)
// ============================================================

// Chart-based filter actions
export const setChartFilters = filters => ({
  type: SET_CHART_FILTERS,
  payload: filters,
})

export const clearChartFilters = () => dispatch => {
  dispatch({ type: CLEAR_CHART_FILTERS })
}

// Cascading filter option actions
export const getAssessmentDomains = (params = {}) => async dispatch =>
  withFilterCache('domains', params, async () => {
    try {
      const queryParams = new URLSearchParams()
      const id = params.assessmentId || params.assessmentInstituteMapId
      if (id) queryParams.append('assessmentId', id)
      if (params.scheduleId) queryParams.append('scheduleId', params.scheduleId)
      if (params.passingYear) queryParams.append('passingYear', params.passingYear)
      if (params.instituteId) queryParams.append('instituteId', params.instituteId)

      const response = await studentRequest.get(
        `/assessment/getDomain?${queryParams.toString()}`
      )

      if (response.data?.message?.toLowerCase() === 'success') {
        const domains = response.data.data?.domains || []
        return domains.map(d => ({ label: d, value: d, name: d, id: d }))
      }
      return []
    } catch (error) {
      console.error('Error fetching assessment domains:', error)
      return []
    }
  })

export const getAssessmentDegrees = (params = {}) => async dispatch =>
  withFilterCache('degrees', params, async () => {
    try {
      const queryParams = new URLSearchParams()
      const id = params.assessmentId || params.assessmentInstituteMapId
      if (id) queryParams.append('assessmentId', id)
      if (params.scheduleId) queryParams.append('scheduleId', params.scheduleId)
      if (params.passingYear) queryParams.append('passingYear', params.passingYear)
      if (params.instituteId) queryParams.append('instituteId', params.instituteId)
      if (params.domains && params.domains.length > 0) {
        queryParams.append('domains', params.domains.join(','))
      }

      const response = await studentRequest.get(
        `/assessment/getDegree?${queryParams.toString()}`
      )

      if (response.data?.message?.toLowerCase() === 'success') {
        const degrees = response.data.data?.degrees || []
        return degrees.map(d => ({ label: d, value: d, name: d, id: d }))
      }
      return []
    } catch (error) {
      console.error('Error fetching assessment degrees:', error)
      return []
    }
  })

export const getAssessmentDepartments = (params = {}) => async dispatch =>
  withFilterCache('departments', params, async () => {
    try {
      const queryParams = new URLSearchParams()
      const id = params.assessmentId || params.assessmentInstituteMapId
      if (id) queryParams.append('assessmentId', id)
      if (params.scheduleId) queryParams.append('scheduleId', params.scheduleId)
      if (params.passingYear) queryParams.append('passingYear', params.passingYear)
      if (params.instituteId) queryParams.append('instituteId', params.instituteId)
      if (params.degrees && params.degrees.length > 0) {
        queryParams.append('degrees', params.degrees.join(','))
      }

      const response = await studentRequest.get(
        `/assessment/getDepartment?${queryParams.toString()}`
      )

      if (response.data?.message?.toLowerCase() === 'success') {
        const departments = response.data.data?.departments || []
        return departments.map(d => ({ label: d, value: d, name: d, id: d }))
      }
      return []
    } catch (error) {
      console.error('Error fetching assessment departments:', error)
      return []
    }
  })

export const getAssessmentSpecializations = (params = {}) => async dispatch =>
  withFilterCache('specializations', params, async () => {
    try {
      const queryParams = new URLSearchParams()
      const id = params.assessmentId || params.assessmentInstituteMapId
      if (id) queryParams.append('assessmentId', id)
      if (params.scheduleId) queryParams.append('scheduleId', params.scheduleId)
      if (params.passingYear) queryParams.append('passingYear', params.passingYear)
      if (params.instituteId) queryParams.append('instituteId', params.instituteId)
      if (params.departments && params.departments.length > 0) {
        queryParams.append('departments', params.departments.join(','))
      }

      const response = await studentRequest.get(
        `/assessment/getSpecialization?${queryParams.toString()}`
      )

      if (response.data?.message?.toLowerCase() === 'success') {
        const specializations = response.data.data?.specializations || []
        return specializations.map(s => ({ label: s, value: s, name: s, id: s }))
      }
      return []
    } catch (error) {
      console.error('Error fetching assessment specializations:', error)
      return []
    }
  })

export const getYearOfPassing = instituteId => async dispatch => {
  try {
    const response = await studentRequest.get(
      `/students/institutes/${instituteId}/yearOfPassing`
    )
    return response.data.data
  } catch (error) {
    console.error('Error fetching year of passing:', error)
    return []
  }
}

// Fetch assessment states (KPI data) for an institute
export const fetchAssessmentStatesForInstitute = (params) => async (dispatch) => {
  dispatch({ type: FETCH_ASSESSMENT_STATES_REQUEST })
  try {
    const { instituteId, passingYear } = params
    const response = await studentRequest.get(
      '/students/assessments/getAssessmentStatesForInstitute/' + instituteId,
      {
        params: {
          passingYear
        }
      }
    )
    dispatch({
      type: FETCH_ASSESSMENT_STATES_SUCCESS,
      payload: response.data,
    })
    return response.data
  } catch (error) {
    console.error('Error fetching assessment states:', error)
    dispatch({
      type: FETCH_ASSESSMENT_STATES_FAILURE,
      payload: error.message,
    })
  }
}

// Fetch TPO student list
export const fetchTpoStudentList = (params) => async (dispatch) => {
  dispatch({ type: FETCH_TPO_STUDENT_LIST_REQUEST })
  try {
    const {
      instituteId,
      pageNumber = 1,
      pageSize = 10,
      searchParams = '',
      passingYear = '',
      domain = [],
      degree = [],
      department = [],
      specialization = [],
      sortBy = { field: 'name', order: 'asc' }
    } = params
    const response = await studentRequest.post(
      `/students/assessments/tpo/student-list/${instituteId}`,
      {
        pageNumber,
        pageSize,
        searchParams,
        passingYear,
        domain: domain.join(','),
        degree: degree.join(','),
        department: department.join(','),
        specialization: specialization.join(','),
        sortBy
      }
    )
    dispatch({
      type: FETCH_TPO_STUDENT_LIST_SUCCESS,
      payload: response.data,
    })
    return response.data
  } catch (error) {
    console.error('Error fetching TPO student list:', error)
    dispatch({
      type: FETCH_TPO_STUDENT_LIST_FAILURE,
      payload: error.message,
    })
  }
}

// Export TPO student list to Excel
export const exportTpoStudentListToExcel = (params = {}) => async dispatch => {
  try {
    const response = await studentRequest.post(
      `/assessment/exportTpoStudentList/${params.instituteId}`,
      {
        searchParams: params.searchParams || '',
        passingYear: params.passingYear || '',
        domain: params.domain || [],
        degree: params.degree || [],
        department: params.department || [],
        specialization: params.specialization || [],
        sortBy: params.sortBy || { field: 'name', order: 'asc' }
      },
      {
        responseType: 'blob'
      }
    )

    // Extract filename from Content-Disposition header
    let filename = 'TPO Student List.xlsx'
    const contentDisposition = response.headers['content-disposition']
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/)
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1]
      }
    }

    // Create download link
    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = filename
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)

    return true
  } catch (error) {
    console.error('[exportTpoStudentListToExcel] ERROR:', error)
    throw error
  }
}

export const exportStudentListToExcel = (params = {}) => async dispatch => {
  try {
    const response = await studentRequest.post(
      `/assessment/exportStudentListForAssessment/${params.instituteId}`,
      {
        assessmentId: params.assessmentId || '',
        assessmentType: params.assessmentType || '',
        searchParams: params.searchTerm || '',
        search: params.searchTerm || '',
        passingYear: params.passingYear || '',
        domain: params.domain || [],
        degree: params.degree || [],
        department: params.department || [],
        specialization: params.specialization || [],
        Cefr: params.Cefr || [],
        AptitudeLevel: params.AptitudeLevel || [],
        consistency: params.consistency || [],
        statusFilter: params.statusFilter || [],
        sortBy: params.sortBy || { field: 'name', order: 'asc' },
      },
      { responseType: 'blob' }
    )

    let filename = 'Student_List.xlsx'
    const contentDisposition = response.headers['content-disposition']
    if (contentDisposition) {
      const match = contentDisposition.match(/filename="?([^"]+)"?/)
      if (match?.[1]) filename = match[1]
    }

    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', filename)
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.URL.revokeObjectURL(url)
  } catch (error) {
    console.error('[exportStudentListToExcel] ERROR:', error)
    throw error
  }
}

export const fetchDiagnosisData = (params) => async dispatch => {
  try {
    const response = await studentRequest.post(
      '/assessment/getDiagnosisDataForASchedule',
      {
        scheduleId: params.scheduleId,
        passingYear: params.passingYear || '',
        searchTerm: params.searchTerm || '',
        domain: params.domain || [],
        degree: params.degree || [],
        department: params.department || [],
        specialization: params.specialization || [],
        pageNumber: params.pageNumber || 1,
        pageSize: params.pageSize || 10,
        sortBy: params.sortBy || { field: 'name', order: 'asc' },
        Cefr: Array.isArray(params.cefrLevel) ? params.cefrLevel : (params.cefrLevel ? [params.cefrLevel] : []),
        AptitudeLevel: Array.isArray(params.aptitudeLevel) ? params.aptitudeLevel : (params.aptitudeLevel ? [params.aptitudeLevel] : []),
        consistency: Array.isArray(params.consistency) ? params.consistency : (params.consistency ? [params.consistency] : [])
      }
    )

    const message = response.data?.message?.toLowerCase()
    if (message === 'success') {
      const payload = response.data.data
      return payload
    }
    return null
  } catch (error) {
    console.error('[fetchDiagnosisData] ERROR:', error)
    return null
  }
}

export const exportDiagnosisDataToExcel = (params = {}) => async dispatch => {
  try {
    const response = await studentRequest.post(
      '/assessment/exportDiagnosisDataForSchedule',
      {
        scheduleId: params.scheduleId,
        searchTerm: params.searchTerm || '',
        passingYear: params.passingYear || '',
        domain: params.domain || [],
        degree: params.degree || [],
        department: params.department || [],
        specialization: params.specialization || [],
        Cefr: params.Cefr || [],
        AptitudeLevel: params.AptitudeLevel || [],
        consistency: params.consistency || [],
        sortBy: params.sortBy || { field: 'name', order: 'asc' }
      },
      { responseType: 'blob' }
    )

    let filename = 'Diagnosis Report.xlsx'
    const contentDisposition = response.headers['content-disposition']
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/)
      if (filenameMatch && filenameMatch[1]) filename = filenameMatch[1]
    }

    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', filename)
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.URL.revokeObjectURL(url)
  } catch (error) {
    console.error('[exportDiagnosisDataToExcel] ERROR:', error)
    throw error
  }
}

export const updateScheduleAssessment = (payload) => async (dispatch) => {
  dispatch({ type: UPDATE_SCHEDULE_ASSESSMENT_REQUEST });
  try {
    const response = await adminRequest.put('/assessment/schedule', payload);
    dispatch({
      type: UPDATE_SCHEDULE_ASSESSMENT_SUCCESS,
      payload: response?.data?.data,
    });
    return response?.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to update schedule';
    dispatch({ type: UPDATE_SCHEDULE_ASSESSMENT_FAILURE, payload: errorMessage });
    throw error;
  }
};

export const getScheduleAssessment = (scheduleId) => async (dispatch) => {
  dispatch({ type: GET_SCHEDULE_ASSESSMENT_REQUEST });
  try {
    const response = await adminRequest.get('/assessment/schedule', {
      params: { scheduleId },
    });
    dispatch({
      type: GET_SCHEDULE_ASSESSMENT_SUCCESS,
      payload: response?.data?.data,
    });
    return response?.data?.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch schedule';
    dispatch({ type: GET_SCHEDULE_ASSESSMENT_FAILURE, payload: errorMessage });
    throw error;
  }
};

export const fetchProgressionTimeline = (email, type, instituteId, upToAssessmentId) => async () => {
  try {
    const params = { email, type }
    if (instituteId) params.instituteId = instituteId
    if (upToAssessmentId) params.upToAssessmentId = upToAssessmentId
    const response = await studentRequest.get('/assessment/progression-timeline', { params })
    return response?.data?.data || { timeline: [], delta: null }
  } catch (error) {
    console.error('[fetchProgressionTimeline] ERROR:', error)
    return { timeline: [], delta: null }
  }
}

export const exportScheduleToExcel = (scheduleId, instituteId, passingYear) => async () => {
  try {
    const response = await studentRequest.post(
      `/assessment/exportSchedule/${scheduleId}`,
      { instituteId, passingYear },
      { responseType: 'blob' }
    )
    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', `schedule-${scheduleId}.xlsx`)
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.URL.revokeObjectURL(url)
  } catch (error) {
    console.error('[exportScheduleToExcel] ERROR:', error)
    throw error
  }
}
